import React, { Component, Fragment } from "react";

import Ruleonpage from "./ruleonloterry"
import SweetAlert from 'react-bootstrap-sweetalert';
import { NumericFormat } from 'react-number-format';
import socketIOClient from 'socket.io-client'
import axios from 'axios';
import instanceHuay from "./axios-instanceHuay";
import instance from "./axios-instance";
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2';
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import Systems from "./SystemFunction";
import { isMobile } from "react-device-detect";
const input = document.querySelector('input');

class Lottery extends Component {
    constructor(props) {
        super(props)
        this.state = {
            countdownMain: {
                days: "00",
                hours: "00",
                minutes: "00",
                seconds: "00",
            },
            isHidden: false,
            player: {
                "status": 0,
                "timestamps": 0,
                "balance": 0,
                "currency": "THB"
            },
            numberSets: [],
            loadingSendBuy: false,
            isPageLoading: true,
            isOpen: false, // State to track whether the `open` class is applied
            limitNumberSettings: [],
            isModalOpen: false, // สถานะของ Modal
            room: '',
            option_2: '',
            shuffleanme: '',
            statehuay: true,
            track: '',
            type: 3,
            System: "",
            items: [],
            isOpenx: false,
            isOpenxprint: false,
            isOpensend: false,
            numbertype: 3,
            typename: '',
            email: '',
            currentUser: null,
            result1: '',
            result2: '',
            rulehtml: '',
            result3: '',
            name: props.name,
            price: 1,
            setpilltype: '000',
            alert: null,
            list: [],
            checkboxlist: [],
            Dynamicsetting: [],
            reverseStatus: { "3digit": false, "2digit": false }, // ค่าเริ่มต้น
            shuffle: '',
            roomid: '',
            uid: '',
            pricetotal: [],
            usercontext: []

        }
        this.handleClick = this.handleClick.bind(this);
        this.handleClicklastindex = this.handleClicklastindex.bind(this);
        this.toggleOpenx = this.toggleOpenx.bind(this);

    }
    toggleSidebar = () => {
        this.setState((prevState) => ({
            isHidden: !prevState.isHidden,
        }));
    };
    toggleOpenx = async () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

        // 2) ล็อคไม่ให้พื้นหลังเลื่อน (กันผู้ใช้สไลด์แล้ว background ขยับ)
        document.body.style.overflow = 'hidden';
        await this.fetchPoyList();

        this.setState((prevState) => ({
            isOpenx: !prevState.isOpenx, // Toggle the state
        }));
    };
    lockSendButton = (on, selector = '.triggerPrintpoy') => {
        // 2.1 เซ็ตแฟลกให้ JSX รู้ (คุม disabled/class)
        this._sendLocked = !!on;
        if (typeof this.forceUpdate === 'function') this.forceUpdate();

        // 2.2 แต่งปุ่มฝั่ง DOM (เปลี่ยนข้อความเป็นกำลังส่ง ฯลฯ)
        this._btnCache = this._btnCache || {};
        let btn = this._btnCache[selector];
        if (!btn || !document.body.contains(btn)) {
            btn = document.querySelector(selector);
            if (btn) this._btnCache[selector] = btn;
        }
        if (!btn) return;

        if (on) {
            if (!btn._origHtml) btn._origHtml = btn.innerHTML;
            btn.innerHTML = '<i class="fas fa-circle-notch fa-spin"></i> กำลังส่ง...';
        } else {
            if (btn._origHtml) btn.innerHTML = btn._origHtml;
        }
    };

    sendBuyList = async () => {
        if (this._sendingBuy) return;

        this._sendingBuy = true;
        this.setState({ loadingSendBuy: true });

        try {
            const { room, player } = this.state;

            this.lockSendButton(true, ".triggerPrintpoy");

            const allItemNumbers = Object.keys(this.state)
                .filter((key) => key.startsWith("ItemNumber_"))
                .flatMap((key) => this.state[key]);

            if (!allItemNumbers || allItemNumbers.length === 0) {
                Swal.fire({
                    icon: "warning",
                    title: "ไม่มีข้อมูลตัวเลข",
                    text: "กรุณาเลือกตัวเลขก่อนส่ง",
                });
                return;
            }

            const uniqueItemNumber = Object.keys(this.state)
                .filter((key) => key.startsWith("ItemNumber_"))
                .flatMap((key) => {
                    const keyid = key.replace("ItemNumber_", "");
                    return this.state[key].map((item) => ({
                        ...item,
                        keyid,
                    }));
                })
                .filter(
                    (item, index, self) =>
                        index ===
                        self.findIndex(
                            (t) =>
                                t.keyid === item.keyid &&
                                t.value === item.value &&
                                t.price === item.price
                        )
                )
                .map((item) => ({
                    number: item.value || "",
                    price: item.price || 0,
                    payout: item.payout || 0,
                    status: item.status === "normal" ? 1 : item.status,
                    keyid: item.keyid || "",
                }))
                .filter((item) => item.number && item.keyid);

            const filteredItems = uniqueItemNumber.filter(
                (item) => item.status !== "limit"
            );

            const updatedItemState = {};

            Object.keys(this.state)
                .filter((key) => key.startsWith("ItemNumber_"))
                .forEach((key) => {
                    updatedItemState[key] = this.state[key].filter(
                        (item) => item.status !== "limit"
                    );
                });

            this.setState(updatedItemState);

            if (filteredItems.length === 0) {
                Swal.fire({
                    icon: "error",
                    title: "ไม่มีรายการที่ส่งได้",
                    text: "ทุกหมายเลขถูกจำกัดลิมิต",
                });
                return;
            }

            const now = new Date();
            const year = now.getFullYear();
            const timestamp = String(now.getTime()).slice(-4);
            const uniqueId = uuidv4().split("-")[0];

            const track = `TRK-${year}${timestamp}-${uniqueId}`;

            const payload = {
                roomid: room.roomid,
                playerid: player.username,
                items: filteredItems,
                track,
                dateadd: new Date(),
                system: room?.system,
                priceset: filteredItems.reduce((sum, item) => sum + item.price, 0),
            };

            const response = await instanceHuay.post("/api/v1/addBuyList", payload);

            if (response.status === 200) {
                if (typeof this.props.onRefreshCredit === "function") {
                    await this.props.onRefreshCredit();
                }

                this.setState({
                    track,
                    isOpenxprint: true,
                });

                await this.notify("success", "ส่งโพยเรียบร้อย");
            } else {
                Swal.fire({
                    icon: "error",
                    title: "เกิดข้อผิดพลาด",
                    text: response.data.message,
                });
            }
        } catch (error) {
            if (error.response?.status === 401) {
                Swal.fire({
                    icon: "error",
                    title: "ยอดเงินไม่เพียงพอ",
                    text: "โปรดเติมเงินที่หน้าแคชเชียร์",
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "ข้อผิดพลาดระบบ",
                    text: error.message,
                });
            }
        } finally {
            this._sendingBuy = false;
            this.lockSendButton(false, ".triggerPrintpoy");
            this.setState({ loadingSendBuy: false });
        }
    };



    handleSelectSet = (setId) => {
        const { numberSets, Dynamicsetting } = this.state;

        // Find the selected set by ID
        const selectedSet = numberSets.find((set) => set._id === setId);

        if (!selectedSet) {
            console.error("Set not found");
            return;
        }

        // Filter numbers that match enabled DynamicSetting
        const filteredNumbers = selectedSet.poyNumbers.filter((poy) => {
            const dynamic = Dynamicsetting.find(
                (setting) => setting.keyid === poy.keyid && setting.enabled === 1
            );
            return Boolean(dynamic); // Only include if the DynamicSetting is enabled
        });

        // Update state for each `keyid`
        const updatedState = {};
        filteredNumbers.forEach((poy) => {
            const key = `ItemNumber_${poy.keyid}`;
            updatedState[key] = [...(this.state[key] || []), { keyid: poy.keyid, value: poy.number }];
        });

        // Update the state with the new ItemNumbers
        this.setState(updatedState);

        document.body.style.overflow = '';
        this.setState({ isOpenx: false });
        console.log("Updated State:", updatedState);
    };



    CheckThisGoalErrorprice() {
        const getAlert = () => (
            <SweetAlert
                error
                title="invalid!"
                onConfirm={() => this.continueAlert()}  >
                คุณซื้อตัวเลขเกินวงเงินที่คุณมี กรุณาตรวจสอบ หรือเติมเงินเข้าระบบ
            </SweetAlert>
        );

        this.setState({
            alert: getAlert()
        });
    }

    CheckThisGoalSuccess() {
        const getAlert = () => (
            <SweetAlert
                success
                title="Success!"
                onConfirm={() => this.hideAlert()}  >
                คุณทำการซื้อหวยสำเร็จ
            </SweetAlert>
        );

        this.setState({
            alert: getAlert()
        });
    }

    hideAlert() {
        this.setState({
            ItemNumberThree: [],
            ItemNumberThreelang: [],
            ItemNumberTwo: [],
            ItemNumberTwolang: [],
            alert: null
        });
    }

    startCountdownMain = (targetTime) => {
        if (this.interval) clearInterval(this.interval); // กัน setInterval ซ้อน
        this.interval = setInterval(() => {
            const now = new Date().getTime();
            const diff = new Date(targetTime).getTime() - now;

            if (diff > 0) {
                const days = Math.floor(diff / (1000 * 60 * 60 * 24));
                const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((diff % (1000 * 60)) / 1000);

                this.setState({
                    countdownMain: {
                        days: days < 10 ? `0${days}` : `${days}`,
                        hours: hours < 10 ? `0${hours}` : `${hours}`,
                        minutes: minutes < 10 ? `0${minutes}` : `${minutes}`,
                        seconds: seconds < 10 ? `0${seconds}` : `${seconds}`,
                    },
                });
            } else {
                clearInterval(this.interval);
                this.setState({
                    countdownMain: {
                        days: "00",
                        hours: "00",
                        minutes: "00",
                        seconds: "00",
                    },
                });
                // ✅ Redirect เมื่อหมดเวลา
                this.setState({
                    statehuay: false,
                });
                // window.location.href = "/error";
            }
        }, 1000);
    };


    CheckThisGoalRoomError(text) {
        const getAlert = () => (
            <SweetAlert
                error
                title="invalid!"
                onConfirm={() => this.continueAlert()}  >
                {text}
            </SweetAlert>
        );

        this.setState({
            alert: getAlert()
        });
    }
    handleToggle = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
        document.body.style.overflow = 'hidden';
        this.setState((prevState) => ({
            isOpen: !prevState.isOpen, // Toggle the `isOpen` state
        }));
    };
    // calculateItemsAndTotalPrice = () => {
    //     // Filter state keys that start with "ItemNumber_"
    //     const itemKeys = Object.keys(this.state).filter((key) => key.startsWith("ItemNumber_"));

    //     // Initialize counters
    //     let totalItems = 0;
    //     let totalPrice = 0;

    //     // Loop through each key
    //     itemKeys.forEach((key) => {
    //         const items = this.state[key] || []; // Get the array of items
    //         totalItems += items.length; // Add the count of items
    //         totalPrice += items.reduce((sum, item) => sum + (item.price || 0), 0); // Sum up the prices
    //     });

    //     return { totalItems, totalPrice };
    // };

    calculateItemsAndTotalPrice = (state = this.state) => {
        const itemKeys = Object.keys(state).filter(k => k.startsWith("ItemNumber_"));
        let totalItems = 0;
        let totalPrice = 0;

        for (const key of itemKeys) {
            const items = Array.isArray(state[key]) ? state[key] : [];
            for (const it of items) {
                const price = Number(it?.price) || 0; // กัน string/NaN
                totalItems += 1;
                totalPrice += price;
            }
        }
        return { totalItems, totalPrice };
    };


    handleViewDuplicate = () => {
        const updatedState = {};

        // กรองคีย์ที่เริ่มต้นด้วย "ItemNumber_"
        Object.keys(this.state)
            .filter((key) => key.startsWith("ItemNumber_"))
            .forEach((key) => {
                const items = this.state[key] || [];
                const seenValues = new Set();
                const duplicateValues = new Set();

                // ตรวจสอบเลขซ้ำ
                items.forEach((item) => {
                    if (seenValues.has(item.value)) {
                        duplicateValues.add(item.value);
                    } else {
                        seenValues.add(item.value);
                    }
                });

                // เพิ่มฟิลด์ isDuplicate สำหรับเลขซ้ำ
                const updatedItems = items.map((item) => ({
                    ...item,
                    isDuplicate: duplicateValues.has(item.value),
                }));

                updatedState[key] = updatedItems;
            });

        // อัปเดต state พร้อมข้อมูลเลขซ้ำ
        this.setState(updatedState, () => {
            Swal.fire({
                icon: "info",
                title: "ตรวจสอบเลขซ้ำเสร็จสิ้น",
                text: "เลขซ้ำจะถูกเน้นด้วยสีที่แตกต่าง!",
            });
        });
    };
    componentWillUnmount() {
        // Remove the event listener to prevent memory leaks
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    async _fetchAndUpdateTheme(Systems, cacheKey) {
        try {
            const res = await instance.post("/api/v1/getthemesv", { System: Systems });
            if (res.data.status === 200) {
                const theme = res.data.ThmeseLottoV;
                const current = (this.state && this.state.ThmeseLottoV) || document.body.getAttribute("data-theme");
                if (theme && theme !== current) {
                    // update UI + state + cache
                    document.body.setAttribute("data-theme", theme);
                    this.setState({ ThmeseLottoV: theme });
                    if (this.setCache) this.setCache(cacheKey, theme);
                } else {
                    // ถ้าเหมือนกัน อัปเดต cache timestamp เท่านั้น (เพื่อรีเซ็ต TTL)
                    if (this.setCache) this.setCache(cacheKey, theme);
                }
            }
        } catch (err) {
            throw err;
        }
    }
    getCache = (key, ttl) => {
        const cachedData = JSON.parse(localStorage.getItem(key));
        if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
            return cachedData.data;
        }
        return null;
    };
    setCache = (key, data) => {
        localStorage.setItem(key, JSON.stringify({
            timestamp: Date.now(),
            data: data,
        }));
    };
    async callgetthemesv(Systems) {
        const cacheKey = "theme_v1";            // ปรับชื่อ key ตามต้องการ
        const ttl = 24 * 60 * 60 * 1000;        // 24 ชั่วโมง (ปรับถ้าต้องการ 1 ชั่วโมง = 3600000)
        console.log("callgetthemesv", Systems)
        // 1) ถ้ามี cache ที่ยัง valid ให้ใช้ทันที (fast)
        const cached = this.getCache ? this.getCache(cacheKey, ttl) : null;
        if (cached) {
            // Apply cached theme right away
            document.body.setAttribute("data-theme", cached);
            this.setState({ ThmeseLottoV: cached });
            // แต่ยังทำ background fetch เพื่อตรวจสอบ/รีเฟรช (stale-while-revalidate)
            this._fetchAndUpdateTheme(Systems, cacheKey).catch(err => console.error("theme background fetch:", err));
            return;
        }

        // 2) ถ้าไม่มี cache ให้รอ fetch ปกติ (first load)
        try {
            const res = await instance.post("/api/v1/getthemesv", { System: Systems });
            if (res.data.status === 200) {
                const theme = res.data.ThmeseLottoV;
                document.body.setAttribute("data-theme", theme);
                this.setState({ ThmeseLottoV: theme });
                console.log("callgetthemesv", Systems)
                // save cache
                if (this.setCache) this.setCache(cacheKey, theme);
            }
        } catch (err) {
            console.error("callgetthemesv error:", err);
            // ถ้า fetch ล้มเหลว ไม่ต้องทำอะไรเพิ่มเติม (ถ้ามี cached value จะใช้ของเก่า)
        }
    }
    async componentDidMount() {
        try {

            const queryString = window.location.search;
            const params = new URLSearchParams(queryString);
            const param1 = params.get("roomid");
            const param2 = params.get("code");
            const param3 = params.get("handshake");
            // const typename = localStorage.getItem('typename');
            const stateKeys = JSON.parse(localStorage.getItem('stateKeys')) || {};
            const { totalItems, totalPrice } = this.calculateItemsAndTotalPrice();
            this.setState({ totalItems, totalPrice });
            //  console.log(typename, "typenametypenametypenametypenametypename");
            // if (!typename) {
            //   //  this.setState({ typename });
            // }
            // this.setState({ ...stateKeys });
            window.addEventListener('keydown', this.handleKeyDown);
            //console.log(param2);
            try {
                const apiUrl = "/api/v1/getRooms?system=SYSTEM&roomid=" + param1 + "&encode=" + param2 + "";
                // Headers
                const headers = {
                    'Content-Type': 'application/json',
                };
                try {
                    const response = await instanceHuay.get(apiUrl, { headers });
                    console.log("/api/v1/getrooms?system=SYSTEM&roomid=", response.data);
                    const room = response.data.rooms[0];
                    const drawTime = new Date(room.drawTime);
                    const now = new Date();

                    await this.callgetthemesv(response.data?.rooms[0]?.system)
                    if (drawTime <= now && room.status === 0) {
                        window.location.href = `/poyreward/${window.location.search}`;
                    }
                    if (response.data.rooms.length > 0) {
                        const room = response.data.rooms[0];
                        const dyn = room.dynamicSetting || [];
                        const first = dyn.find(s => s.enabled === 1); // << ตัวแรกที่เปิดใช้

                        this.setState({
                            room,
                            Dynamicsetting: dyn,
                            limitNumberSettings: room.limitNumberSettings,
                            System: room.system,
                            // ตั้งค่าเริ่มต้นกันลืมเลือกประเภท
                            typename: first ? first.keyid : '',
                            type: first ? first.digit : 0,
                            numbertype: first ? first.digit : 0,
                            activeTypes: first ? { [first.keyid]: true } : {},
                        }, () => {
                            this.startCountdownMain(room.datetimeClose);
                        });
                    } else {
                        window.location.href = response.data.callback;
                    }
                    // if (response.data.rooms.length > 0) {
                    //     this.setState({ room: response.data.rooms[0], Dynamicsetting: response.data.rooms[0].dynamicSetting, limitNumberSettings: response.data.rooms[0].limitNumberSettings });
                    //     this.startCountdownMain(response.data.rooms[0].drawTime);
                    // }
                    // else {
                    //     window.location.href = response.data.callback;
                    // }

                } catch (error) {
                    console.error('Error fetching rooms:', error.message);
                    window.location.href = "/"
                }

            } catch (ex) {
                console.log(ex)
            }
            try {
                const apiUrl = "/api/v1/getbalance?encodedPlayerid=" + param2;
                const headers = {
                    'Content-Type': 'application/json',
                    'handshake': param3
                };
                try {
                    const response = await instanceHuay.get(apiUrl, { headers });
                    this.setState({ player: response.data.data });
                    // console.log('API Response:', apiUrl, response.data.data);
                } catch (error) {
                    console.error('Error fetching rooms:', error.message);
                    throw error;
                }

            } catch (ex) {

            }

        } finally {
            this.setState({ isPageLoading: false });
        }
    }

    CheckThisGoalError() {
        const getAlert = () => (
            <SweetAlert
                error
                title="invalid!"
                onConfirm={() => this.continueAlert()}  >
                คุณเพิ่มวงเงินเกิดขอบเขตการรับแทง ต้องขออภัย
            </SweetAlert>
        );

        this.setState({
            alert: getAlert()
        });
    }

    continueAlert() {
        this.setState({
            alert: null
        });
    }


    CompltelyRule() {
        const { type } = this.state;
        return (<Ruleonpage typeset={type} />)
    }
    // handleClickchagetypemain = (index) => {
    //     console.log("handleClickchagetypemain", index);
    //     this.setState({
    //         shuffle: '',
    //         typename: index.keyid,
    //         type: index.digit,
    //         numbertype: index.digit
    //     });
    // }
    handleClickchagetypemain = (index) => {
        this.setState((prevState) => {
            const currentTypes = prevState.activeTypes || {};
            const isActive = currentTypes[index.keyid] || false;
            const currentDigit = index.digit;

            // กรองเฉพาะปุ่มที่มี digit เดียวกัน
            const filteredTypes = Object.keys(currentTypes).reduce((acc, key) => {
                const item = prevState.Dynamicsetting.find((item) => item.keyid === key);
                if (item?.digit === currentDigit) {
                    acc[key] = currentTypes[key];
                }
                return acc;
            }, {});

            return {
                shuffle: '', // รีเซ็ต shuffle
                typename: index.keyid, // อัปเดต typename ตาม keyid
                type: index.digit, // อัปเดต type ตาม digit
                numbertype: index.digit, // อัปเดต numbertype ตาม digit
                activeTypes: {
                    ...filteredTypes,
                    [index.keyid]: !isActive, // สลับสถานะ active/inactive
                },
            };
        });
    };


    CompltelyType() {
        return (
            <Fragment>
                {this.state.Dynamicsetting
                    .filter((option) => option.enabled === 1) // กรองเฉพาะ enabled === 1
                    .map((setting, index) => {
                        const isActive = this.state.activeTypes?.[setting.keyid] || false; // ตรวจสอบสถานะ active จาก activeTypes
                        return (
                            <span
                                key={index}
                                className={`badge font-weight-light ${isActive
                                    ? setting.digit === 3
                                        ? "badge-danger"
                                        : setting.digit === 2
                                            ? "badge-primary"
                                            : "badge-success"
                                    : "d-none"
                                    }`}
                                id={`${setting.keyid}_label`}
                            >
                                {setting.key}
                            </span>
                        );
                    })}
            </Fragment>


        )
    }
    handleDeleteItem = (key, index) => {
        this.setState((prevState) => {
            const updatedItems = prevState[key].filter((_, idx) => idx !== index);

            return { [key]: updatedItems };
        });
    };
    handleClose = () => {
        document.body.style.overflow = '';
        this.setState({ isOpen: false }); // Set `isOpen` to false to close the modal
    };


    toggleModal = () => {
        document.body.style.overflow = '';
        this.setState({ isOpenx: false }); // Set `isOpen` to false to close the modal
    };

    openModal = async () => {
        console.log("handleShowModalRule", this.state.room);
        await instanceHuay.get('/api/v1/rules', {
            params: { roomMaster: this.state.room.roomMaster, system: this.state.room.system.toLowerCase() },
        }).then((res) => {
            if (res.status === 200) {
                console.log("handleShowModalRule", res.data.data.rulehtml);
                this.setState({ rulehtml: res.data.data.rulehtml || '', isModalOpen: true });
                // this.setState({ prolistx: res.data.message });
            }
        }).catch((err) => {

            console.log("handleShowModalRule", err);
            // if (err.response.status === 401 || err.response.status === 403) {
            //     localStorage.clear();
            //     this.notify("warning", 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง');
            //     window.location.href = '/';
            // }
        });
    };

    // ฟังก์ชันปิด Modal
    closeModal = () => {
        this.setState({ isModalOpen: false });
    };

    handleClickLastIndex = () => {
        Swal.fire({
            title: 'ยืนยันการยกเลิก?',
            text: 'คุณต้องการลบรายการล่าสุดหรือไม่?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'ใช่, ลบรายการ!',
            cancelButtonText: 'ยกเลิก',
        }).then((result) => {
            if (result.isConfirmed) {
                const { typename } = this.state; // Use `typename` to find the correct array
                const indexName = `ItemNumber_${typename}`;

                // Check if the typename is selected and if the array exists
                if (typename && this.state[indexName]?.length > 0) {
                    // Remove the last item from the array
                    const updatedArray = [...this.state[indexName]];
                    updatedArray.pop(); // Remove the last item

                    // Update the state
                    this.setState({
                        [indexName]: updatedArray,
                    });

                    // Optionally update localStorage
                    localStorage.setItem(indexName, JSON.stringify(updatedArray));

                    Swal.fire('ลบรายการสำเร็จ!', 'รายการล่าสุดถูกลบเรียบร้อยแล้ว', 'success');
                } else {
                    Swal.fire('ไม่มีรายการ!', 'ไม่พบรายการที่สามารถลบได้', 'info');
                }
            }
        });
    };
    // sendpoy = () => {

    //     this.setState({ isOpensend: true, isOpenx: false });
    // }

    sendpoy = async () => {
        const { room, player } = this.state;

        const allItemNumbers = Object.keys(this.state)
            .filter((key) => key.startsWith("ItemNumber_"))
            .flatMap((key) => this.state[key]);

        if (!allItemNumbers || allItemNumbers.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "ไม่มีข้อมูลตัวเลข",
                text: "กรุณาเลือกตัวเลขก่อนส่ง",
            });
            return;
        }

        const uniqueItemNumber = Object.keys(this.state)
            .filter((key) => key.startsWith("ItemNumber_"))
            .flatMap((key) => {
                const keyid = key.replace("ItemNumber_", "");
                return this.state[key].map((item) => ({
                    ...item,
                    keyid,
                }));
            })
            .filter(
                (item, index, self) =>
                    index ===
                    self.findIndex(
                        (t) => t.keyid === item.keyid && t.value === item.value && t.price === item.price
                    )
            )
            .map((item) => ({
                number: item.value || "",
                price: item.price || 0,
                payout: item.payout || 0,
                status: item.status || 1,
                keyid: item.keyid || "",
            }))
            .filter((item) => item.number && item.keyid);

        if (uniqueItemNumber.length === 0) {
            Swal.fire({
                icon: "error",
                title: "ข้อมูลตัวเลขไม่สมบูรณ์",
                text: "โปรดตรวจสอบตัวเลขและประเภทก่อนส่ง",
            });
            return;
        }

        const payload = {
            roomid: room.roomid,
            roommaster: room.roomMaster,
            playerid: player.username,
            items: uniqueItemNumber,
            system: room?.system,
        };

        console.log(payload);

        try {
            const response = await instanceHuay.post("/api/v1/checkLimit", payload);
            console.log("/api/v1/checkLimit", response);
            if (response.status === 200) {
                // Update the consolidated items array
                console.log("/api/v1/items", this.state.items);

                const updatedItems = this.state.items.map((stateItem) => {
                    const matchedItem = response.data.data.find(
                        (item) =>
                            item.number.toString() === stateItem.number.toString() &&
                            item.keyid === stateItem.keyid
                    );

                    return matchedItem
                        ? {
                            ...stateItem,
                            payout: matchedItem.payout,
                            status: matchedItem.status,
                            price: matchedItem.price,
                            message: matchedItem.message,
                        }
                        : stateItem;
                });

                // Update individual ItemNumber_* keys
                const updatedState = Object.keys(this.state)
                    .filter((key) => key.startsWith("ItemNumber_"))
                    .reduce((acc, key) => {
                        acc[key] = this.state[key].map((item) => {
                            const matchedItem = response.data.data.find(
                                (responseItem) =>
                                    responseItem.number.toString() === item.value.toString() &&
                                    responseItem.keyid === key.replace("ItemNumber_", "")
                            );

                            return matchedItem
                                ? {
                                    ...item,
                                    status: matchedItem.status,
                                    payout: matchedItem.payout,
                                    price: matchedItem.price,
                                    message: matchedItem.message,
                                }
                                : item;
                        });
                        return acc;
                    }, {});

                // Merge updated items and individual keys into state
                window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

                // 2) ล็อคไม่ให้พื้นหลังเลื่อน (กันผู้ใช้สไลด์แล้ว background ขยับ)
                document.body.style.overflow = 'hidden';
                this.setState({ items: updatedItems, ...updatedState, isOpensend: true }, () => {
                    console.log("Updated items state:", updatedItems);
                    console.log("Updated ItemNumber_* state:", updatedState);
                });
            }
            else if (response.status === 401) {
                Swal.fire({
                    icon: "warning",
                    title: "ยังไม่เปิดให้ซื้อขาย",
                    text: response.data.message || "ยังไม่เปิดให้ซื้อขาย",
                });
            }

        } catch (error) {
            console.error("Error during /api/v1/checkLimit:", error);

            const status = error.response?.status;

            if (status === 401 || status === 402) {
                Swal.fire({
                    icon: "warning",
                    title: "ยังไม่เปิดให้ซื้อขาย",
                    text: error.response?.data?.message || "ยังไม่เปิดให้ซื้อขาย",
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "ข้อผิดพลาดระบบ",
                    text: error.response?.data?.message || "ไม่สามารถตรวจสอบลิมิตได้",
                });
            }
        }
    };


    closesendpoy = (back) => {
        document.body.style.overflow = '';
        if (back) this.setState({ isOpensend: false, isOpenx: false });
        else this.setState({ isOpensend: false });

    };

    closesallpoy = (back) => {
        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith("ItemNumber_")) {
                localStorage.removeItem(key);
            }
        });
        // Reset state
        this.setState({
            typename: "",
            isOpenxprint: true,
            result1: "",
            result2: "",
            result3: "",
            ...Object.keys(this.state).reduce((acc, key) => {
                if (key.startsWith("ItemNumber_")) {
                    acc[key] = [];
                }
                return acc;
            }, {}),
        });
        this.setState({
            isOpensend: false
            , isOpenxprint: false
            , isOpen: false
            , isModalOpen: false
        });
        document.body.style.overflow = '';
    };
    notify = async (mode, msg) => {
        console.log(mode, msg);
        if (mode == "success") {
            await toast.success(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeonClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "warning") {
            await toast.warning(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeonClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "error") {
            await toast.error(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeonClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        else if (mode == "info") {
            await toast.info(msg, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeonClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
            });
        }
        await this.waitnotify();
    }
    waitnotify = async () => {
        setTimeout(() => { console.log('World!') }, 5000)
    }
    handleClickClear = () => {
        Swal.fire({
            title: 'ยืนยันการล้างข้อมูล?',
            text: 'คุณต้องการล้างข้อมูลทั้งหมดหรือไม่?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'ใช่, ล้างข้อมูล!',
            cancelButtonText: 'ยกเลิก',
        }).then((result) => {
            if (result.isConfirmed) {
                // Clear local storage
                Object.keys(localStorage).forEach((key) => {
                    if (key.startsWith("ItemNumber_")) {
                        localStorage.removeItem(key);
                    }
                });

                // Reset state
                this.setState({
                    typename: '',
                    result1: '',
                    result2: '',
                    result3: '',
                    option_2: '',
                    // Clear dynamic arrays
                    ...Object.keys(this.state).reduce((acc, key) => {
                        if (key.startsWith("ItemNumber_")) {
                            acc[key] = [];
                        }
                        return acc;
                    }, {}),
                });

                // Show success message
                Swal.fire('ล้างข้อมูลสำเร็จ!', 'ข้อมูลทั้งหมดถูกลบเรียบร้อยแล้ว', 'success');
            }
        });
    };
    generateNumbers = (start, count, type) => {
        //  console.log(start, count, type, "generateNumbers");
        if (type == 2) {
            console.log("type:", type); // ตรวจว่าเป็น 2 จริงไหม
            return Array.from({ length: 100 }, (_, i) => {
                return i.toString().padStart(2, "0");
            });
        }

        return Array.from({ length: count }, (_, i) => {
            const number = (start + i).toString().padStart(3, "0").slice(-3);
            return number;
        });
    };

    // Handle pill type change
    handlepilltype = (index) => {
        this.setState({ setpilltype: index });
    };

    // Handle main type change


    // Handle shuffle type change
    // Handle shuffle type change
    // handleClickchagetypesuffle = (shuffleType) => {

    //     this.setState((prevState) => {
    //         const currentShuffle = prevState.shuffle;
    //         const targetShuffle = `shuffle_${shuffleType}`;
    //         const { numbertype } = this.state;
    //         // กำหนดค่า shuffle ใหม่ ถ้า currentShuffle ไม่ตรงกับ targetShuffle
    //         console.log(shuffleType, numbertype)
    //         if (numbertype == shuffleType) {
    //             const newShuffle = currentShuffle === targetShuffle ? '' : targetShuffle;
    //             console.log('Current shuffle:', currentShuffle);
    //             console.log('Shuffle type:', shuffleType);
    //             console.log('Target shuffle:', targetShuffle);
    //             console.log('New shuffle:', newShuffle);
    //             return { shuffle: newShuffle };
    //         }
    //     });
    // };

    handleClickchagetypesuffle = (digit) => {
        this.setState(prev => {
            // ใช้ digit ของ typename ที่เลือกอยู่ (กันกรณี numbertype ไม่ตรง/เป็น string)
            const current = prev.Dynamicsetting.find(s => s.keyid === prev.typename);
            const currentDigit = current?.digit ?? Number(prev.numbertype) ?? 0;

            // กดปุ่มสลับคนละ digit กับชนิดที่เลือก → ไม่ทำอะไร
            if (currentDigit !== Number(digit)) return {};

            const target = `shuffle_${digit}`;
            return { shuffle: prev.shuffle === target ? '' : target };
        });
    };

    renderPills = () => {
        const { numbertype, setpilltype } = this.state;
        // Only render if numbertype is 3
        if (numbertype == 2) return null;
        // Generate pill values dynamically
        const pillValues = Array.from({ length: 10 }, (_, i) => i * 100);

        return (
            <div id="samtua">
                <div id="oversamtua">
                    <ul className="nav nav-pills mb-3 justify-content-center" id="numlist-tab1" role="tablist">
                        {pillValues.map((value) => (
                            <li key={value} className="nav-item flex-fill text-center">
                                <a
                                    className={`nav-link border m-1 px-1 txt-num ${setpilltype === value ? "active" : ""}`}
                                    onClick={() => this.handlepilltype(value)}
                                    id={`tab-${value}`}
                                    data-toggle="pill"
                                    href={`#pills-${value}`}
                                    role="tab"
                                    aria-controls={`pills-${value}`}
                                    aria-selected={setpilltype === value}
                                >
                                    {value.toString().padStart(3, "0")}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        );
    };
    createNumber = () => {
        const { type, setpilltype, typename } = this.state;
        const numbers = this.generateNumbers(setpilltype, 100, type);

        return (
            <Fragment>
                <>{this.renderPills()}</>
                <div className="text-center">
                    {numbers.map((number, i) => {
                        // ตรวจสอบว่า number มีอยู่ใน ItemNumber_
                        const isChecked = this.state[`ItemNumber_${typename}`]?.some(
                            item => item.value === number
                        );

                        return (
                            <div
                                key={i}
                                className="btn-group-toggle column d-inline"
                                data-toggle="buttons"
                            >
                                <label
                                    id={number}
                                    onClick={() => this.handleNumberClick(number)}
                                    className={`checkbox btn btn-outline-danger btn-sm mb-1 panghuay_number ${isChecked ? "active" : ""}`}
                                >
                                    <input
                                        id={number}
                                        type="checkbox"
                                        value={number}
                                        checked={isChecked}
                                        readOnly
                                    />
                                    {number}
                                </label>
                            </div>
                        );
                    })}
                </div>
            </Fragment>
        );
    };


    handleNumberClick = (number) => {
        const { typename } = this.state;

        if (!typename) {
            Swal.fire({
                icon: 'warning',
                title: 'กรุณาเลือกประเภท',
                text: 'คุณต้องเลือกประเภทก่อนที่จะเพิ่มตัวเลข!',
            });
            return;
        }

        const indexName = `ItemNumber_${typename}`;
        const currentItems = [...(this.state[indexName] || [])];

        // ตรวจสอบว่าตัวเลขมีอยู่ในรายการแล้วหรือไม่
        const exists = currentItems.some(item => item.value === number);

        let updatedItems;
        if (exists) {
            // ถ้ามีอยู่แล้วให้ลบออก
            updatedItems = currentItems.filter(item => item.value !== number);
        } else {
            // ถ้ายังไม่มีให้เพิ่ม
            const newItem = {
                index: currentItems.length + 1,
                value: number,
                price: 1,
                type: this.state.type,
            };
            updatedItems = [...currentItems, newItem];
        }

        // อัปเดต state พร้อม callback
        this.setState({
            [indexName]: updatedItems,
        }, () => {
            console.log("Updated ItemNumber_:", this.state[indexName]);
        });
    };


    generate19Numbers = () => {
        const selectedSetting = this.state.Dynamicsetting.find(
            (setting) => setting.keyid === this.state.typename
        );

        if (!selectedSetting || selectedSetting.digit !== 2) {
            // Ensure the selected type is valid and has 2 digits
            return [];
        }

        const baseDigit = this.state.result1 || "0"; // Default to "0" if `result1` is not set
        const numbers = [];

        for (let i = 0; i <= 9; i++) {
            if (i !== parseInt(baseDigit, 10)) {
                numbers.push(`${baseDigit}${i}`);
                numbers.push(`${i}${baseDigit}`);
            }
        }

        return [...new Set(numbers)].sort(); // Remove duplicates and sort
    };

    handleGenerateNumbers = () => {
        const generatedNumbers = this.generate19Numbers();

        // Dynamically update state based on the selected digit
        const selectedSetting = this.state.Dynamicsetting.find(
            (setting) => setting.keyid === this.state.typename
        );

        if (!selectedSetting) return;

        const updates = {};
        generatedNumbers.slice(0, selectedSetting.digit).forEach((number, index) => {
            updates[`result${index + 1}`] = number;
        });

        this.setState({ ItemNumber_: generatedNumbers, ...updates });
    };



    CompltelyPad() {

        return (
            <Fragment>
                <div className="group__keyboard" >
                    <div className="num-pad box__show-number">
                        <h4 className="text-center numbertext " >ระบุตัวเลข</h4>
                        <div className="label-number lists">
                            <div id="bet_num">
                                {this.state.Dynamicsetting
                                    .filter((option) => option.enabled === 1)
                                    .filter((setting) => this.state.typename === setting.keyid)
                                    .sort((a, b) => b.digit - a.digit)
                                    .map((setting, index) => {
                                        // 👇 โหมดที่ต้องให้กรอกแค่ 1 หลัก
                                        const isSweepMode = ["option_2_roodnha", "option_2_roodlung", "option_2_19"]
                                            .includes(this.state.option_2);

                                        // จำนวนช่องที่จะแสดงใน UI
                                        const digitsNormal = Number(setting.digit ?? this.state.numbertype ?? 2);
                                        const displayDigits = isSweepMode ? 1 : digitsNormal;

                                        // เก็บค่าที่กรอกไว้ result1..resultN ตามจำนวนช่องที่จะโชว์
                                        const results = Array.from({ length: displayDigits }, (_, i) =>
                                            this.state[`result${i + 1}`] ?? ""
                                        );

                                        // index ของช่องว่างตัวแรก (-1 ถ้ากรอกครบ)
                                        const firstEmpty = results.findIndex(v => v === "");

                                        return (
                                            <div key={index} className="number-group">
                                                {results.map((val, i) => (
                                                    <label key={i} className="number">
                                                        {val !== "" ? val : (firstEmpty === i ? <span></span> : "")}
                                                    </label>
                                                ))}
                                            </div>
                                        );
                                    })}

                                {/* {this.state.Dynamicsetting
                                    .filter((option) => option.enabled === 1)
                                    .filter((setting) => this.state.typename === setting.keyid)
                                    .sort((a, b) => b.digit - a.digit)
                                    .map((setting, index) => {
                                        const results = Array.from(
                                            { length: this.state.numbertype },
                                            (_, i) => this.state[`result${i + 1}`] ?? ""
                                        );

                                        const firstEmpty = results.findIndex(v => v === "");

                                        return (
                                            <div key={index} className="number-group">
                                                {results.map((val, i) => (
                                                    <label key={i} className="number">
                                                        {val !== ""
                                                            ? val                        
                                                            : (firstEmpty === i ? <span></span> : "")} 
                                                    </label>
                                                ))}
                                            </div>
                                        );
                                    })} */}

                            </div>

                        </div>
                        <div className="key-pad box__keyboard">
                            <div className="row p-2">
                                <div className="col-3">
                                    <button onClick={this.handleClick} className="btn btn-outline-primary btn-block" id="1">1</button>
                                </div>
                                <div className="col-3">
                                    <button onClick={this.handleClick} className="btn btn-outline-primary btn-block" id="2">2</button>
                                </div>
                                <div className="col-3">
                                    <button onClick={this.handleClick} className="btn btn-outline-primary btn-block" id="3">3</button>
                                </div>
                                <div className="col-3">
                                    <button className="btn btn-danger btn-block" onClick={() => {
                                        console.log("typename:", this.state.typename);
                                        this.handleDeleteLastResult(this.state.typename);
                                    }} id="delete"><i className="fas fa-backspace"></i></button>
                                </div>
                                <div className="col-3">
                                    <button onClick={this.handleClick} className="btn btn-outline-primary btn-block" id="4">4</button>
                                </div>
                                <div className="col-3">
                                    <button onClick={this.handleClick} className="btn btn-outline-primary btn-block" id="5">5</button>
                                </div>
                                <div className="col-3">
                                    <button onClick={this.handleClick} className="btn btn-outline-primary btn-block" id="6">6</button>
                                </div>
                                <div className="col-3">
                                    <button onClick={this.handleClickLastIndex} className="btn btn-secondary btn-block btn-cancel warning btn-cancle-last-add-num"><span>ยกเลิก</span></button>
                                </div>
                                <div className="col-3">
                                    <button onClick={this.handleClick} className="btn btn-outline-primary btn-block" id="7">7</button>
                                </div>
                                <div className="col-3">
                                    <button onClick={this.handleClick} className="btn btn-outline-primary btn-block" id="8">8</button>
                                </div>
                                <div className="col-3">
                                    <button onClick={this.handleClick} className="btn btn-outline-primary btn-block" id="9">9</button>
                                </div>
                                <div className="col-3">
                                    <button className="btn btn-dark btn-block btn-reset" onClick={this.handleClickClear} ><span>ล้าง</span><span>ข้อมูล</span></button>
                                </div>
                                <div className="col-3">
                                    <button className="btn btn-blank" disabled=""></button>
                                </div>
                                <div className="col-3">
                                    <button onClick={this.handleClick} className="btn btn-outline-primary btn-block" id="0">0</button>
                                </div>
                                <div className="col-3">
                                    <button className="btn btn-blank" disabled=""></button>
                                </div>
                                <div className="col-3">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }

    getShuffledFromDigits = (digitsArr) => {
        if (digitsArr.length === 2) {
            const [a, b] = digitsArr;
            return [`${b}${a}`];
        }
        if (digitsArr.length === 3) {
            const [a, b, c] = digitsArr;
            // ชุด perm ที่ไม่ซ้ำกับ a b c เดิม
            return Array.from(new Set([
                `${a}${c}${b}`,
                `${b}${a}${c}`,
                `${b}${c}${a}`,
                `${c}${a}${b}`,
                `${c}${b}${a}`,
            ]));
        }
        return [];
    };


    appendNumbersToCurrentType = (numbers) => {
        const { typename, type } = this.state;
        if (!typename) {
            Swal.fire({
                icon: 'warning',
                title: 'กรุณาเลือกประเภท',
                text: 'คุณต้องเลือกประเภทก่อนที่จะเพิ่มตัวเลข!',
            });
            return;
        }
        const key = `ItemNumber_${typename}`;
        const current = this.state[key] || [];
        const exists = new Set(current.map(it => String(it.value)));

        const toAdd = [];
        numbers.forEach(num => {
            const v = String(num);
            if (!exists.has(v)) {
                toAdd.push({
                    index: current.length + toAdd.length + 1,
                    value: v,
                    price: 1,
                    type,
                });
                exists.add(v);
            }
        });

        if (toAdd.length) {
            this.setState({ [key]: [...current, ...toAdd] });
        }
    };


    handleSetAllPrices = (e) => {
        const { value } = e.target; // Get the input value

        if (!value || isNaN(value)) return; // Ignore invalid or empty values

        const updatedState = {};
        const maxBetSettings = this.state.Dynamicsetting; // Assuming this holds the maxBet settings
        const limitNumberSettings = this.state.limitNumberSettings; // Limit settings for specific numbers

        // Iterate over all `ItemNumber_*` keys in the state
        Object.keys(this.state)
            .filter((key) => key.startsWith("ItemNumber_")) // Filter keys starting with `ItemNumber_`
            .forEach((key) => {
                const keyid = key.replace("ItemNumber_", ""); // Extract keyid
                const setting = maxBetSettings.find((s) => s.keyid === keyid); // Find corresponding maxBet setting

                const updatedList = this.state[key].map((item) => {
                    const maxBet = setting?.maxBet || 0; // Get maxBet or default to 0 (no limit)
                    const limitSetting = limitNumberSettings.find(
                        (limit) => limit.number === item.value && limit.Settings.keyid === keyid
                    ); // Find limit setting for this item

                    let newPrice = parseFloat(value);

                    // Enforce limitPerPerson if applicable
                    if (limitSetting?.limitPerPerson > 0 && newPrice > limitSetting.limitPerPerson) {
                        newPrice = limitSetting.limitPerPerson;
                    }
                    // Enforce maxBet limit if applicable
                    else if (maxBet > 0 && newPrice > maxBet) {
                        newPrice = maxBet;
                    }

                    return { ...item, price: newPrice }; // Update price
                });

                updatedState[key] = updatedList;
            });

        // Update the state with the modified lists
        this.setState(updatedState, () => {
            console.log("Updated prices in all lists:", updatedState);

            // Optionally update localStorage
            // localStorage.setItem("state", JSON.stringify(this.state));
        });
    };

    handleSetAllPricesxx = (e) => {
        const amount = e.currentTarget.getAttribute('data-id'); // ดึงค่า data-id
        if (!amount || isNaN(amount)) return; // ตรวจสอบว่าข้อมูลถูกต้อง

        const parsedAmount = parseInt(amount, 10); // แปลงเป็นจำนวนเต็ม
        const { Dynamicsetting: maxBetSettings, limitNumberSettings } = this.state; // ดึงข้อมูลจาก state

        this.setState((prevState) => {
            const updatedState = {};

            // ค้นหา keys ที่เริ่มต้นด้วย "ItemNumber_"
            Object.keys(prevState)
                .filter((key) => key.startsWith("ItemNumber_"))
                .forEach((key) => {
                    const keyid = key.replace("ItemNumber_", ""); // แปลง key ให้เป็น keyid
                    const maxBetSetting = maxBetSettings.find((setting) => setting.keyid === keyid); // หาค่า maxBet

                    updatedState[key] = prevState[key].map((item) => {
                        const maxBet = maxBetSetting?.maxBet || Infinity; // ค่า maxBet (ถ้าไม่มีให้ใช้ Infinity)
                        const limitSetting = limitNumberSettings.find(
                            (limit) => limit.number === item.value && limit.Settings.keyid === keyid
                        ); // หาค่า limitPerPerson

                        let newPrice = parsedAmount;

                        // ใช้ limitPerPerson ก่อน
                        if (limitSetting?.limitPerPerson > 0 && newPrice > limitSetting.limitPerPerson) {
                            newPrice = limitSetting.limitPerPerson;
                        }

                        // จากนั้นตรวจสอบ maxBet
                        if (newPrice > maxBet) {
                            newPrice = maxBet;
                        }

                        return { ...item, price: newPrice }; // อัปเดตราคา
                    });
                });

            return updatedState; // คืนค่าที่อัปเดต
        }, () => {
            console.log("Updated prices with limitPerPerson and maxBet constraints:", this.state);
        });
    };
    CompltelyBtnType() {
        return (
            <Fragment>
                <div className="row px-2 row-btn-tanghuay setting__number">

                    {this.state.Dynamicsetting
                        .filter(option => option.enabled === 1) // กรองเฉพาะ enabled === 1
                        .sort((a, b) => b.digit - a.digit) // เรียงลำดับ digit จากมากไปน้อย
                        .map((setting, index) => (
                            <div className="col-6 col-sm-6 col-md-4 col-lg-3 " style={{ padding: "0.13rem" }}>
                                <button
                                    name={setting.keyid}
                                    className={`btn btn-outline-${setting.digit === 3
                                        ? "red"
                                        : setting.digit === 2
                                            ? "blue"
                                            : "green"
                                        } btn-sm btn-block h-100 d-flex justify-content-between align-items-center btn-tanghuay ${this.state.activeTypes?.[setting.keyid] ? "active" : ""
                                        }`}
                                    id={setting.keyid}
                                    onClick={() => this.handleClickchagetypemain(setting)}
                                >
                                    <div
                                        className={`bg-${setting.digit === 3
                                            ? "danger"
                                            : setting.digit === 2
                                                ? "primary"
                                                : "success"
                                            } text-white`}
                                    >
                                        <i>{setting.key}</i>
                                    </div>
                                    <div>{setting.value}</div>
                                </button>

                            </div>
                        ))}
                    {this.state.Dynamicsetting
                        .filter(option => option.enabled === 1 && (option.digit === 2 || option.digit === 3)) // กรองเฉพาะ enabled === 1 และ digit เป็น 2 หรือ 3
                        .sort((a, b) => b.digit - a.digit) // เรียงลำดับ digit จากมากไปน้อย
                        .reduce((uniqueDigits, setting) => {
                            // เก็บเฉพาะ digit ที่ยังไม่มีใน uniqueDigits
                            if (!uniqueDigits.some(item => item.digit === setting.digit)) {
                                uniqueDigits.push(setting);
                            }
                            return uniqueDigits;
                        }, [])
                        .map((setting, index) => (
                            <div className="col-6 col-sm-6 col-md-4 col-lg-3" key={index} style={{ padding: "0.13rem" }}>
                                <button
                                    className={`btn btn-outline-${setting.digit === 3 ? "red" : "blue"} btn-sm btn-block mt-1 h-100 d-flex justify-content-between align-items-center btn-tanghuay ${this.state.shuffle === `shuffle_${setting.digit}` ? "active" : ""}`}
                                    onClick={() => this.handleClickchagetypesuffle(setting.digit)}
                                >
                                    <div
                                        className={`bg-${setting.digit === 3 ? "danger" : "primary"} text-white`}
                                    >
                                        <i>{`${setting.digit} ตัวกลับ`}</i>
                                    </div>
                                    <div><i class="fas fa-random"></i></div>
                                </button>
                            </div>
                        ))}


                </div>
            </Fragment>



        )
    }

    handleClicklastindex(e) {
        const { ItemNumberThree } = this.state;
        var index = ItemNumberThree.length - 1;
        if (index !== -1) {
            ItemNumberThree.splice(index, 1);
            this.setState({
                ItemNumberThree: ItemNumberThree,
                result1: '',
                result2: '',
                result3: ''
            });
        }
    }
    handleDeleteDuplicate = () => {
        // แสดงการยืนยันด้วย Swal
        Swal.fire({
            title: "ยืนยันการตัดเลขซ้ำ?",
            text: "คุณต้องการลบเลขที่ซ้ำกันออกและเก็บไว้เพียงรายการเดียวหรือไม่?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "ใช่, ลบเลขซ้ำ!",
            cancelButtonText: "ยกเลิก",
        }).then((result) => {
            if (result.isConfirmed) {
                const updatedState = {};
                let duplicatesRemoved = false;

                // กรองคีย์ที่ขึ้นต้นด้วย "ItemNumber_"
                Object.keys(this.state)
                    .filter((key) => key.startsWith("ItemNumber_"))
                    .forEach((key) => {
                        const items = this.state[key] || [];
                        const uniqueItems = [];
                        const seenValues = new Set();

                        items.forEach((item) => {
                            if (!seenValues.has(item.value)) {
                                uniqueItems.push(item); // เก็บรายการที่ยังไม่ซ้ำ
                                seenValues.add(item.value);
                            } else {
                                duplicatesRemoved = true; // พบเลขซ้ำ
                            }
                        });

                        updatedState[key] = uniqueItems; // อัปเดตรายการใหม่
                    });

                // หากลบเลขซ้ำได้ อัปเดต state
                if (duplicatesRemoved) {
                    this.setState(updatedState, () => {
                        Swal.fire(
                            "สำเร็จ!",
                            "เลขซ้ำถูกลบออกเรียบร้อยแล้ว!",
                            "success"
                        );
                    });
                } else {
                    Swal.fire(
                        "ไม่มีเลขซ้ำ!",
                        "ไม่พบเลขซ้ำในรายการ!",
                        "info"
                    );
                }
            }
        });
    };


    fetchPoyList = async () => {
        const { room, player } = this.state;
        console.log("player", player)
        this.setState({ isLoading: true, error: null });
        try {
            const response = await instanceHuay.post("/api/v1/getpoylist", {
                playerid: player?.username,
                system: room.system,
            });

            if (response.status === 200 && response.data.success) {
                this.setState({ numberSets: response.data.data, isLoading: false });
            } else {
                this.setState({ isLoading: false });
            }
        } catch (error) {
            this.setState({ isLoading: false });
        }
    };

    handleNumberInput(e) {
        const { numbertype, shuffle, option_2 } = this.state;
        const { target: { id } } = e;

        if (numbertype === 0 && option_2 == "option_2_19") {

            if (this.state.result1 === '') {
                this.setState({
                    result1: id
                })
            }

            if (this.state.result1 !== '' || this.state.result1 !== '') {
                var index = this.state.ItemNumberTwo.length;
                if (index === 0) index = 1;
                else index += 1;
                const obj = {
                    'index': index,
                    'value': this.state.result1 + id,
                    'price': this.state.price,
                    'type': this.state.type
                }
                const newArray = this.state.ItemNumberTwo.slice();
                newArray.push(obj);

                if (shuffle === "shuffle_2") {
                    const obj1 = {
                        'index': index + 1,
                        'value': id + this.state.result1,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj1)
                }

                this.setState({
                    ItemNumberTwo: newArray,
                    result1: '',
                    result2: '',
                    result3: '',
                })
            }
        }
        else if (numbertype === 1) {
            if (this.state.result1 === '') {
                this.setState({
                    result1: id
                })
            }
            else if (this.state.result2 === '') {
                this.setState({
                    result2: id
                })
            }
            if (this.state.result1 !== '' && this.state.result2 === '' || this.state.result1 !== '' && this.state.result2 !== '') {
                var index = this.state.ItemNumberTwo.length;
                if (index === 0) index = 1;
                else index += 1;
                const obj = {
                    'index': index,
                    'value': this.state.result1 + id,
                    'price': this.state.price,
                    'type': this.state.type
                }
                const newArray = this.state.ItemNumberTwo.slice();
                newArray.push(obj);

                if (shuffle === "shuffle_2") {
                    const obj1 = {
                        'index': index + 1,
                        'value': id + this.state.result1,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj1)
                }

                this.setState({
                    ItemNumberTwo: newArray,
                    result1: '',
                    result2: '',
                    result3: '',
                })
            }
        }
        else if (numbertype === 2) {
            if (this.state.result1 === '') {
                this.setState({
                    result1: id
                })
            }
            else if (this.state.result2 === '') {
                this.setState({
                    result2: id
                })
            }
            if (this.state.result1 !== '' && this.state.result2 === '' || this.state.result1 !== '' && this.state.result2 !== '') {
                var indexone = this.state.ItemNumberTwolang.length;
                if (indexone === 0) indexone = 1;
                else indexone += 1;
                const obj = {
                    'index': indexone,
                    'value': this.state.result1 + id,
                    'price': this.state.price,
                    'type': this.state.type
                }
                const newArray = this.state.ItemNumberTwolang.slice();
                newArray.push(obj);


                if (shuffle === "shuffle_2") {
                    const obj1 = {
                        'index': index + 1,
                        'value': id + this.state.result1,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj1)
                }


                this.setState({
                    ItemNumberTwolang: newArray,
                    result1: '',
                    result2: '',
                    result3: '',
                })
            }
        }
        else if (numbertype === 3) {
            if (this.state.result1 === '') {
                this.setState({
                    result1: id
                })
            }

            else if (this.state.result2 === '') {
                this.setState({
                    result2: id
                })
            }

            else if (this.state.result3 === '') {
                this.setState({
                    result3: id
                })
            }

            if (this.state.result1 !== '' && this.state.result2 !== '' && this.state.result3 === '') {
                var indexthree = this.state.ItemNumberThree.length;
                if (indexthree === 0) indexthree = 1;
                else indexthree += 1;
                const obj = {
                    'index': indexthree,
                    'value': this.state.result1 + this.state.result2 + id,
                    'price': this.state.price,
                    'type': this.state.type
                }
                const newArray = this.state.ItemNumberThree.slice();
                newArray.push(obj);



                if (shuffle === "shuffle_3") {
                    const obj1 = {
                        'index': indexthree + 1,
                        'value': this.state.result1 + id + this.state.result2,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj1);

                    const obj2 = {
                        'index': indexthree + 2,
                        'value': id + this.state.result1 + this.state.result2,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj2);

                    const obj3 = {
                        'index': indexthree + 3,
                        'value': id + this.state.result2 + this.state.result1,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj3);

                    const obj4 = {
                        'index': indexthree + 4,
                        'value': this.state.result2 + id + this.state.result1,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj4);
                }

                this.setState({
                    ItemNumberThree: newArray,
                    result1: '',
                    result2: '',
                    result3: '',
                })
            }
        }
        else if (numbertype === 4) {
            if (this.state.result1 === '') {
                this.setState({
                    result1: id
                })
            }

            else if (this.state.result2 === '') {
                this.setState({
                    result2: id
                })
            }

            else if (this.state.result3 === '') {
                this.setState({
                    result3: id
                })
            }

            if (this.state.result1 !== '' && this.state.result2 !== '' && this.state.result3 === '') {
                var indexs = this.state.ItemNumberThreelang.length;
                if (indexs === 0) indexs = 1;
                else indexs += 1;
                const obj = {
                    'index': indexs,
                    'value': this.state.result1 + this.state.result2 + id,
                    'price': this.state.price,
                    'type': this.state.type
                }
                var newArray = this.state.ItemNumberThreelang.slice();
                newArray.push(obj);

                if (shuffle === "shuffle_3") {
                    const obj1 = {
                        'index': indexs + 1,
                        'value': this.state.result1 + id + this.state.result2,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj1);

                    const obj2 = {
                        'index': indexs + 2,
                        'value': id + this.state.result1 + this.state.result2,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj2);

                    const obj3 = {
                        'index': indexs + 3,
                        'value': id + this.state.result2 + this.state.result1,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj3);

                    const obj4 = {
                        'index': indexs + 4,
                        'value': this.state.result2 + id + this.state.result1,
                        'price': this.state.price,
                        'type': this.state.type
                    }
                    newArray.push(obj4);
                }



                this.setState({
                    ItemNumberThreelang: newArray,
                    result1: '',
                    result2: '',
                    result3: '',
                })
            }
        }

    }
    // componentDidUpdate(prevProps, prevState) {
    //     // Persist data to localStorage whenever the state updates
    //     const { typename, ...otherState } = this.state;
    //     localStorage.setItem('typename', typename);
    //     localStorage.setItem('stateKeys', JSON.stringify(otherState));
    //     if (
    //         Object.keys(this.state).some(
    //             (key) =>
    //                 key.startsWith("ItemNumber_") &&
    //                 this.state[key] !== prevState[key]
    //         )
    //     ) {
    //         const { totalItems, totalPrice } = this.calculateItemsAndTotalPrice();
    //         this.setState({ totalItems, totalPrice });
    //     }

    // }

    componentDidUpdate(prevProps, prevState) {
        // A) ถ้า parent ส่ง props roomid/code/handshake เปลี่ยนมา
        // ให้ sync ลง state (ถ้าคุณ "จำเป็น" ต้องมีใน state)
        const propsChanged =
            prevProps.roomid !== this.props.roomid ||
            prevProps.code !== this.props.code ||
            prevProps.handshake !== this.props.handshake;

        if (propsChanged) {
            // กัน setState ซ้ำถ้าค่าใน state ตรงอยู่แล้ว
            if (
                this.state.roomid !== this.props.roomid ||
                this.state.code !== this.props.code ||
                this.state.handshake !== this.props.handshake
            ) {
                this.setState({
                    roomid: this.props.roomid || "",
                    code: this.props.code || "",
                    handshake: this.props.handshake || "",
                });
            }
        }

        // B) localStorage: เขียนเฉพาะตอน typename เปลี่ยน
        if (prevState.typename !== this.state.typename) {
            localStorage.setItem("typename", this.state.typename);
        }

        // stateKeys: แนะนำให้เขียนเมื่อ "state เปลี่ยนจริง"
        // (อย่างน้อยอย่าเขียนทุกครั้งถ้าไม่จำเป็น)
        if (prevState !== this.state) {
            const { typename, totalItems, totalPrice, ...otherState } = this.state;
            localStorage.setItem("stateKeys", JSON.stringify(otherState));
        }

        // C) คำนวณ total แล้ว setState เฉพาะเมื่อค่าเปลี่ยนจริง
        const { totalItems, totalPrice } = this.calculateItemsAndTotalPrice();

        if (
            totalItems !== this.state.totalItems ||
            totalPrice !== this.state.totalPrice
        ) {
            this.setState({ totalItems, totalPrice });
        }
    }
    getCache = (key, ttl) => {
        const cachedData = JSON.parse(localStorage.getItem(key));
        if (cachedData && (Date.now() - cachedData.timestamp < ttl)) {
            return cachedData.data;
        }
        return null;
    };
    async componentDidMount() {
        try {
            // 1) ดึง param จาก URL
            const { roomid, code, handshake } = this.props;

            console.log("props:", roomid, code, handshake);
            // 2) เก็บลง state เพื่อส่งเป็น props ให้ <Lottery />
            this.setState({ roomid, code, handshake });

            // (optional) ถ้า param ขาด ให้พาไป error เลย
            if (!roomid || !code || !handshake) {
                window.location.href = "/";
                return;
            }
            const mainSettingKey = "mainSettingCache";
            const mainSettingTTL = 10 * 60 * 1000; // 30 นาที
            const mainSettingCache = this.getCache(mainSettingKey, mainSettingTTL);

            if (mainSettingCache) {
                console.log("Using cached data for main setting");
                const data = mainSettingCache;

                document.title = (data.tblsetting && data.tblsetting.length > 0) ? data.tblsetting[0].title : "";

                const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                link.type = 'image/svg+xml';
                link.rel = 'icon';
                link.href = (data.tblsetting && data.tblsetting.length > 0) ? data.tblsetting[0].imglogo : "";
                // link.href = data.tblsetting[0].imglogo;
                document.getElementsByTagName('head')[0].appendChild(link);

                this.setState({
                    webname: data.tblsetting?.[0]?.Description || "",
                    logoimg: data.tblsetting?.[0]?.imglogo || "",
                    whellsetting: data.tblwheelsetting || [],
                    maxwithdrawstatus: data.tblcatagoryx?.[0]?.withdrawmax ?? 0,
                    luckywheeldisplay: data.tblwheelsetting?.[0]?.status === 1,
                    linelink: data.message?.[1]?.value || "",
                    webnamex: data.message?.[7]?.value || "",
                    describemain: data.tblsetting?.[0]?.title || "",
                    System: data.tblcatagoryx?.[0]?.System || "",
                    cashoutSet: data.tblcashoutsetting?.[0] || {},
                    inviteSet: data.tblinvitedsetting?.[0] || {},
                    datas: data.message || [],
                    limit: {
                        min: data.tblcatagoryx?.[0]?.limitdeposit ?? 0,
                        max: data.tblcatagoryx?.[0]?.maxdeposit ?? 0
                    },
                });

            }
            // ของเดิมคุณ
            const stateKeys = JSON.parse(localStorage.getItem("stateKeys")) || {};
            const { totalItems, totalPrice } = this.calculateItemsAndTotalPrice();
            this.setState({ totalItems, totalPrice });
            window.addEventListener("keydown", this.handleKeyDown);

            // 3) ใช้ "ตัวแปร" roomid/code/handshake ยิง API (ไม่ต้องรอ setState)
            // --- getRooms
            try {
                const apiUrl = `/api/v1/getRooms?system=SYSTEM&roomid=${encodeURIComponent(roomid)}&encode=${encodeURIComponent(code)}`;
                const headers = { "Content-Type": "application/json" };

                const response = await instanceHuay.get(apiUrl, { headers });
                const room = response.data.rooms?.[0];

                if (!room) {
                    window.location.href = response.data.callback;
                    return;
                }

                const drawTime = new Date(room.drawTime);
                const now = new Date();

                await this.callgetthemesv(room.system);

                if (drawTime <= now && room.status === 0) {
                    window.location.href = `/poyreward/${window.location.search}`;
                    return;
                }

                const dyn = room.dynamicSetting || [];
                const first = dyn.find((s) => s.enabled === 1);

                this.setState(
                    {
                        room,
                        Dynamicsetting: dyn,
                        limitNumberSettings: room.limitNumberSettings,
                        System: room.system,
                        typename: first ? first.keyid : "",
                        type: first ? first.digit : 0,
                        numbertype: first ? first.digit : 0,
                        activeTypes: first ? { [first.keyid]: true } : {},
                    },
                    () => this.startCountdownMain(room.datetimeClose)
                );
            } catch (error) {
                console.error("Error fetching rooms:", error?.message || error);
                window.location.href = "/";
                return;
            }

            // --- getbalance
            try {
                const apiUrl = `/api/v1/getbalance?encodedPlayerid=${encodeURIComponent(code)}`;
                const headers = {
                    "Content-Type": "application/json",
                    handshake: handshake,
                };

                const response = await instanceHuay.get(apiUrl, { headers });
                this.setState({ player: response.data.data });
            } catch (error) {
                console.error("Error fetching balance:", error?.message || error);
                // จะให้ไป /error ด้วยก็ได้ หรือปล่อยให้เล่นต่อ
            }
        } finally {
            this.setState({ isPageLoading: false });
        }
    }


    handleDeleteLastResult = () => {
        // Filter keys that match the "result" pattern
        if (this.state.result3 != "") {
            this.setState({
                result3: "",
            });
        }
        else if (this.state.result2 != "") {
            this.setState({
                result2: "",
            });
        }
        else if (this.state.result1 != "") {
            this.setState({
                result1: "",
            });
        }
    };

    handleKeyDown = (e) => {
        const { key } = e;

        // Check if the key pressed is a number (0-9)
        if (!isNaN(key) && key >= 0 && key <= 9) {
            const isAllFalse = Object.values({
                isOpen: false,
                isOpensend: false,
                isOpensend2: false,
                isModalOpen: false,
                isOpenxprint: false,
                isOpenx: false,
            }).some(value => value === true);
            document.body.style.overflow = '';
            if (isAllFalse) {
                // Simulate button click
                this.handleClick({ target: { id: key } });
            }
        }
    };
    // กดปุ่มบน keypad (ปุ่ม 0-9 ใน UI)
    handleClick = (e) => {
        const id = e?.target?.id;
        if (id == null) return;
        this._pushDigit(id);
    };

    handleKeyDown = (e) => {
        const { isOpen, isModalOpen, isOpenx, isOpenxprint, isOpensend } = this.state;
        if (isOpen == false &&
            isModalOpen == false &&
            isOpenx == false &&
            isOpenxprint == false &&
            isOpensend == false) {

            const { key } = e;
            // ลบตัวสุดท้าย
            if (key === 'Backspace') {
                this.handleDeleteLastResult();
                return;
            }
            // รับเฉพาะตัวเลข 0-9

            if (key >= '0' && key <= '9') {
                this._pushDigit(key);
            }
        }
    };

    // โต๊ด 3 หลัก (กันซ้ำ)
    getTodPermutations = (value) => {
        const [a, b, c] = value.split('');
        return Array.from(new Set([
            `${a}${b}${c}`, `${a}${c}${b}`,
            `${b}${a}${c}`, `${b}${c}${a}`,
            `${c}${a}${b}`, `${c}${b}${a}`,
        ]));
    };

    // เช็คว่า key นี้คือ "โต๊ด" ไหม (ปรับเงื่อนไขตามจริงของระบบคุณ)
    isTodType = (keyid) => {
        const s = this.state.Dynamicsetting.find(x => x.keyid === keyid);
        if (!s) return false;
        const label = (s.key || s.value || '').toString().toLowerCase();
        return label.includes('โต๊ด') || label.includes('tod'); // ปรับได้
    };

    // เพิ่มเลขให้ “หลายชนิด” ทีเดียว
    // appendNumbersToType = (keyid, numbers) => {
    //     console.log(`Appending numbers to ${keyid}:`, numbers);
    //     const key = `ItemNumber_${keyid}`;
    //     const current = this.state[key] || [];
    //     const exists = new Set(current.map(it => String(it.value)));

    //     const toAdd = [];
    //     numbers.forEach((num) => {
    //         const v = String(num);
    //         if (!exists.has(v)) {
    //             toAdd.push({
    //                 index: current.length + toAdd.length + 1,
    //                 value: v,
    //                 price: 1,
    //                 type: this.state.type,
    //             });
    //             exists.add(v);
    //         }
    //     });

    //     if (toAdd.length) {
    //         this.setState({ [key]: [...current, ...toAdd] });
    //     }
    // };

    appendNumbersToType = (keyid, numbers) => {
        const digitMap = {
            firstPrize: "6 digits",
            nearFirstPrize: "6 digits",
            secondPrize: "6 digits",
            fiveDigit: "5 digits",
            fourDigitTop: "4 digits",
            fourDigitTod: "4 digits",

            threeDigitTop: "3 digits",
            threeDigitFront: "3 digits",
            threeDigitBottom: "3 digits",
            threeDigitTod: "3 digits",

            twoDigitBottom: "2 digits",
            twoDigitTop: "2 digits",
            twoDigitTod: "2 digits",

            oneDigitBottom: "1 digit",
            oneDigitTod: "1 digit",
            oneDigitTop: "1 digit",
        };

        const maxByDigitLabel = { "2 digits": 9999, "3 digits": 250 };

        const digitLabel = digitMap[keyid];
        const maxAllowed = maxByDigitLabel[digitLabel];

        if (!digitLabel) {
            console.error("[LIMIT] keyid ไม่อยู่ใน digitMap:", keyid);
            return;
        }

        this.setState((prev) => {
            const groupKeys = Object.keys(digitMap)
                .filter((k) => digitMap[k] === digitLabel)
                .map((k) => `ItemNumber_${k}`);

            const groupCurrent = groupKeys.flatMap((k) => prev[k] || []);
            const groupCount = groupCurrent.length;

            const key = `ItemNumber_${keyid}`;
            const current = prev[key] || [];

            console.groupCollapsed(
                `%c[APPEND] ${keyid} (${digitLabel}) in=${(numbers || []).length} group=${groupCount}/${maxAllowed ?? "∞"}`,
                "color:#0b7285;font-weight:bold"
            );
            console.log("[LIMIT]numbers:", numbers);
            console.log("[LIMIT]groupKeys:", groupKeys);
            console.log("[LIMIT] groupCount:", groupCount, "maxAllowed:", maxAllowed);

            // ✅ limit ยังนับรวมกลุ่มเหมือนเดิม
            if (Number.isFinite(maxAllowed) && groupCount >= maxAllowed) {
                console.warn(
                    `[LIMIT BLOCK] กลุ่ม ${digitLabel} เต็มแล้ว (${groupCount}/${maxAllowed}) -> ไม่เพิ่ม ${keyid}`
                );
                Swal.fire({
                    icon: 'warning',
                    title: 'ไม่สามารถเพิ่มตัวเลขได้',
                    text: `เลข ${digitLabel === '2 digits' ? '2 ตัว' : '3 ตัว'} เลือกได้สูงสุด ${maxAllowed} ตัว`,
                });
                console.groupEnd();
                return null;
            }

            const remaining = Number.isFinite(maxAllowed) ? (maxAllowed - groupCount) : Infinity;

            // ✅ แก้ตรงนี้: duplicate เช็คเฉพาะ “ในประเภทนั้น” เท่านั้น
            // ทำให้ 287 ใส่ได้ทั้ง threeDigitTop และ threeDigitBottom
            const existsInThisType = new Set(current.map((it) => String(it.value)));

            const toAdd = [];
            const dup = [];

            for (const n of (numbers || [])) {
                if (toAdd.length >= remaining) break;

                const v = String(n);
                if (existsInThisType.has(v)) {
                    dup.push(v);
                    continue;
                }

                toAdd.push({
                    index: current.length + toAdd.length + 1,
                    value: v,
                    price: 1,
                    type: prev.type,
                });

                existsInThisType.add(v);
            }

            console.log("[LIMIT]remaining:", remaining);
            console.log("[LIMIT]toAdd.length:", toAdd.length);
            if (dup.length) console.warn("[SKIP dup in same type]", dup);
            console.groupEnd();

            if (!toAdd.length) return null;
            return { [key]: [...current, ...toAdd] };
        });
    };
    appendNumbersToTypes = (mapTypeToNumbers) => {
        // mapTypeToNumbers: { [keyid]: string[] }
        console.log("[APPEND TYPES] mapTypeToNumbers:", mapTypeToNumbers);
        Object.entries(mapTypeToNumbers).forEach(([keyid, nums]) => {
            if (nums && nums.length) this.appendNumbersToType(keyid, nums);
        });
    };


    // _pushDigit = (digit) => {
    //     const { typename, activeTypes = {} } = this.state;
    //     if (!typename) return;

    //     const maxDigits = this.getMaxDigitsForKeyid(typename);
    //     if (!maxDigits) return;

    //     const slots = Array.from({ length: maxDigits }, (_, i) => `result${i + 1}`);

    //     const emptyKey = slots.find(k => !this.state[k]);
    //     if (!emptyKey) return;

    //     this.setState({ [emptyKey]: digit }, () => {
    //         const filled = slots.every(k => (this.state[k] ?? '') !== '');
    //         if (!filled) return;

    //         const digitsArr = slots.map(k => String(this.state[k]));
    //         const value = digitsArr.join('');

    //         // เช็คโต๊ดแบบกันพลาด: ถ้ามี isTodType ใช้, ไม่งั้น fallback ด้วย regex
    //         const isTodKey = (k) => (typeof this.isTodType === 'function'
    //             ? this.isTodType(k)
    //             : /tod/i.test(String(k)));

    //         // keyid ที่ถูกติ๊กไว้ และ digit ตรงกัน
    //         const targetKeys = Object.entries(activeTypes)
    //             .filter(([keyid, on]) => on)
    //             .map(([keyid]) => keyid)
    //             .filter((keyid) => this.getMaxDigitsForKeyid(keyid) === maxDigits);

    //         const numbersByType = {};
    //         for (const keyid of targetKeys) {
    //             if (isTodKey(keyid) && maxDigits === 3) {
    //                 // ✅ 3 ตัวโต๊ด: ห้ามสุ่ม/สลับ/permute — ใช้เลขที่กรอกเพียงรายการเดียว
    //                 numbersByType[keyid] = [value];
    //             } else {
    //                 // ชนิดอื่น: ใช้ shuffle ถ้าผู้ใช้กดปุ่มกลับ
    //                 const useShuffle = this.state.shuffle === `shuffle_${maxDigits}`;
    //                 const arr = useShuffle ? [value, ...this.getShuffledFromDigits(digitsArr)] : [value];
    //                 numbersByType[keyid] = Array.from(new Set(arr.map(String))); // กันซ้ำ
    //             }
    //         }

    //         // กระจายเพิ่มเลขให้ครบทุกชนิดที่เลือก
    //         this.appendNumbersToTypes(numbersByType);

    //         // ล้างช่อง result*
    //         const reset = {};
    //         slots.forEach(k => (reset[k] = ''));
    //         setTimeout(() => this.setState(reset), 120);
    //     });
    // };

    _pushDigit = (digit) => {
        const { typename, activeTypes = {}, option_2 } = this.state;
        if (!typename) return;

        const maxDigits = this.getMaxDigitsForKeyid(typename); // มีอยู่แล้ว
        if (!maxDigits) return;

        // ✅ รูด/19 ประตู: ทำงานเฉพาะ keyid ที่เป็น 2 หลัก
        if (Number(maxDigits) === 2 && option_2) {
            const d = String(digit);

            let bag = [];
            if (option_2 === 'option_2_roodnha') {
                // รูดหน้า: d0..d9
                bag = Array.from({ length: 10 }, (_, i) => `${d}${i}`);
            } else if (option_2 === 'option_2_roodlung') {
                // รูดหลัง: 0d..9d
                bag = Array.from({ length: 10 }, (_, i) => `${i}${d}`);
            } else if (option_2 === 'option_2_19') {
                // 19 ประตู: dX และ Xd
                for (let i = 0; i <= 9; i++) {
                    bag.push(`${d}${i}`);
                    bag.push(`${i}${d}`);
                }
            }

            if (bag.length > 0) {
                // กันซ้ำ เช่น 11 โผล่สองรอบ
                const unique = Array.from(new Set(bag.map(n => n.padStart(2, '0'))));

                // ใส่เฉพาะชนิดที่เป็น 2 หลักและเปิดอยู่ (active)
                const targetKeys = Object.entries(activeTypes)
                    .filter(([keyid, on]) => on)
                    .map(([keyid]) => keyid)
                    .filter((keyid) => this.getMaxDigitsForKeyid(keyid) === 2);

                if (targetKeys.length > 0) {
                    const numbersByType = {};
                    targetKeys.forEach((keyid) => { numbersByType[keyid] = unique; });

                    this.appendNumbersToTypes(numbersByType); // helper เดิม
                    // เคลียร์ช่อง result* ถ้ามี
                    this.setState({ result1: '', result2: '' });
                }
                return; // หยุด ไม่ให้วิ่ง flow ปกติ
            }
        }

        // ---- flow เดิมของคุณ (สอง/สามหลักทั่วไป) อยู่ต่อจากนี้ ----
        const slots = Array.from({ length: maxDigits }, (_, i) => `result${i + 1}`);
        const emptyKey = slots.find(k => !this.state[k]);
        if (!emptyKey) return;

        this.setState({ [emptyKey]: digit }, () => {
            const filled = slots.every(k => (this.state[k] ?? '') !== '');
            if (!filled) return;

            const digitsArr = slots.map(k => String(this.state[k]));
            const value = digitsArr.join('');

            const isTodKey = (k) => (typeof this.isTodType === 'function'
                ? this.isTodType(k)
                : /tod/i.test(String(k)));

            const targetKeys = Object.entries(activeTypes)
                .filter(([keyid, on]) => on)
                .map(([keyid]) => keyid)
                .filter((keyid) => this.getMaxDigitsForKeyid(keyid) === maxDigits);

            const numbersByType = {};
            for (const keyid of targetKeys) {
                if (isTodKey(keyid) && maxDigits === 3) {
                    numbersByType[keyid] = [value];
                } else {
                    const useShuffle = this.state.shuffle === `shuffle_${maxDigits}`;
                    const arr = useShuffle ? [value, ...this.getShuffledFromDigits(digitsArr)] : [value];
                    numbersByType[keyid] = Array.from(new Set(arr.map(String)));
                }
            }

            this.appendNumbersToTypes(numbersByType);

            const reset = {};
            slots.forEach(k => (reset[k] = ''));
            setTimeout(() => this.setState(reset), 120);
        });
    };



    handleDoubleNumbers = () => {
        const { typename } = this.state; // Use typename as the keyid

        // Check if typename is selected
        if (!typename) {
            Swal.fire({
                icon: 'warning',
                title: 'กรุณาเลือกประเภท',
                text: 'คุณต้องเลือกประเภทก่อนที่จะเพิ่มตัวเลข!',
            });
            return; // Stop further execution
        }

        const indexName = `ItemNumber_${typename}`; // Use typename as the identifier for the array
        const newIndex = this.state[indexName]?.length || 0;

        // Generate double numbers
        const doubleNumbers = [];
        for (let i = 0; i <= 9; i++) {
            doubleNumbers.push(`${i}${i}`); // Create double numbers like 00, 11, 22, ...
        }

        const newArray = doubleNumbers.map((num, idx) => ({
            index: newIndex + idx + 1,
            value: num,
            price: 1,
            type: this.state.type,
        }));
        this.notify("success", 'เพิ่มตัวเลข 10 ตัวเรียบร้อย');
        // Update state
        this.setState({
            [indexName]: [...(this.state[indexName] || []), ...newArray],
        });
    };

    handleDoubleNumbers_00_49 = () => {
        const { typename } = this.state; // ใช้ typename เป็น keyid

        // ตรวจสอบว่า typename ถูกเลือกหรือยัง
        if (!typename) {
            Swal.fire({
                icon: 'warning',
                title: 'กรุณาเลือกประเภท',
                text: 'คุณต้องเลือกประเภทก่อนที่จะเพิ่มตัวเลข!',
            });
            return; // หยุดการทำงานถ้าไม่มี typename
        }

        const indexName = `ItemNumber_${typename}`; // ใช้ typename เป็น identifier ของ array
        const newIndex = this.state[indexName]?.length || 0;

        // สร้างเลขทั้งหมด 00 ถึง 49
        const numbers = [];
        for (let i = 0; i <= 49; i++) {
            numbers.push(i.toString().padStart(2, "0")); // เติมเลข 0 ข้างหน้าหากเลขหลักเดียว
        }

        const newArray = numbers.map((num, idx) => ({
            index: newIndex + idx + 1,
            value: num,
            price: 1,
            type: this.state.type,
        }));
        this.notify("success", 'เพิ่มตัวเลข 50 ตัวเรียบร้อย');
        // อัปเดต state
        this.setState({
            [indexName]: [...(this.state[indexName] || []), ...newArray],
        });
    };

    handleDoubleNumbers_50_99 = () => {
        const { typename } = this.state; // ใช้ typename เป็น keyid

        // ตรวจสอบว่า typename ถูกเลือกหรือยัง
        if (!typename) {
            Swal.fire({
                icon: 'warning',
                title: 'กรุณาเลือกประเภท',
                text: 'คุณต้องเลือกประเภทก่อนที่จะเพิ่มตัวเลข!',
            });
            return; // หยุดการทำงานถ้าไม่มี typename
        }

        const indexName = `ItemNumber_${typename}`; // ใช้ typename เป็น identifier ของ array
        const newIndex = this.state[indexName]?.length || 0;

        // สร้างเลขทั้งหมด 50 ถึง 99
        const numbers = [];
        for (let i = 50; i <= 99; i++) {
            numbers.push(i.toString()); // สร้างเลข 50 ถึง 99 โดยไม่ต้องเติม 0 ข้างหน้า
        }

        const newArray = numbers.map((num, idx) => ({
            index: newIndex + idx + 1,
            value: num,
            price: 1,
            type: this.state.type,
        }));
        this.notify("success", 'เพิ่มตัวเลข 50 ตัวเรียบร้อย');
        // อัปเดต state
        this.setState({
            [indexName]: [...(this.state[indexName] || []), ...newArray],
        });
    };

    handleEvenNumbers = () => {
        const { typename } = this.state; // ใช้ typename เป็น keyid

        // ตรวจสอบว่า typename ถูกเลือกหรือยัง
        if (!typename) {
            Swal.fire({
                icon: 'warning',
                title: 'กรุณาเลือกประเภท',
                text: 'คุณต้องเลือกประเภทก่อนที่จะเพิ่มตัวเลข!',
            });
            return; // หยุดการทำงานถ้าไม่มี typename
        }

        const indexName = `ItemNumber_${typename}`; // ใช้ typename เป็น identifier ของ array
        const newIndex = this.state[indexName]?.length || 0;

        // สร้างเลขคู่ 00 ถึง 98
        const evenNumbers = [];
        for (let i = 0; i <= 99; i += 2) {
            evenNumbers.push(i.toString().padStart(2, "0")); // เติมเลข 0 ข้างหน้าหากเลขหลักเดียว
        }

        const newArray = evenNumbers.map((num, idx) => ({
            index: newIndex + idx + 1,
            value: num,
            price: 1,
            type: this.state.type,
        }));
        this.notify("success", 'เพิ่มตัวเลขคู่เรียบร้อย');
        // อัปเดต state
        this.setState({
            [indexName]: [...(this.state[indexName] || []), ...newArray],
        });
    };
    handleOddNumbers = () => {
        const { typename } = this.state; // ใช้ typename เป็น keyid

        // ตรวจสอบว่า typename ถูกเลือกหรือยัง
        if (!typename) {
            Swal.fire({
                icon: 'warning',
                title: 'กรุณาเลือกประเภท',
                text: 'คุณต้องเลือกประเภทก่อนที่จะเพิ่มตัวเลข!',
            });
            return; // หยุดการทำงานถ้าไม่มี typename
        }

        const indexName = `ItemNumber_${typename}`; // ใช้ typename เป็น identifier ของ array
        const newIndex = this.state[indexName]?.length || 0;

        // สร้างเลขคี่ 01 ถึง 99
        const oddNumbers = [];
        for (let i = 1; i <= 99; i += 2) {
            oddNumbers.push(i.toString().padStart(2, "0")); // เติมเลข 0 ข้างหน้าหากเลขหลักเดียว
        }

        const newArray = oddNumbers.map((num, idx) => ({
            index: newIndex + idx + 1,
            value: num,
            price: 1,
            type: this.state.type,
        }));
        this.notify("success", 'เพิ่มตัวเลขคี่เรียบร้อย');
        // อัปเดต state
        this.setState({
            [indexName]: [...(this.state[indexName] || []), ...newArray],
        });
    };


    handlePriceChange = (e, key, index) => {
        const { value } = e.target;
        const maxBetSettings = this.state.Dynamicsetting; // Assuming Dynamicsetting holds the maxBet settings
        const limitNumberSettings = this.state.limitNumberSettings; // Limit settings for specific numbers

        this.setState((prevState) => {
            const keyid = key.replace("ItemNumber_", ""); // Extract keyid
            const setting = maxBetSettings.find((s) => s.keyid === keyid); // Find corresponding maxBet setting
            const maxBet = setting?.maxBet || 0; // Default maxBet if not defined

            const updatedItems = prevState[key].map((item, idx) => {
                if (idx === index) {
                    let newPrice = parseFloat(value) || 0;

                    // Find the corresponding limitNumberSetting for the current number
                    const limitSetting = limitNumberSettings.find(
                        (limit) => limit.number === item.value && limit.Settings.keyid === keyid
                    );

                    // Apply limitPerPerson if it exists, otherwise use maxBet
                    if (limitSetting?.limitPerPerson > 0 && newPrice > limitSetting.limitPerPerson) {
                        newPrice = limitSetting.limitPerPerson; // Cap to limitPerPerson
                    } else if (maxBet > 0 && newPrice > maxBet) {
                        newPrice = maxBet; // Cap to maxBet
                    }

                    return { ...item, price: newPrice };
                }
                return item; // Keep other items unchanged
            });

            return { [key]: updatedItems };
        });
    };


    // Helper function to get max digits for a given `typename`
    getMaxDigitsForKeyid = (typename) => {
        const setting = this.state.Dynamicsetting.find((item) => item.keyid === typename);
        return setting ? setting.digit : 1; // Default to 1 if no match
    };

    // Helper function to generate all shuffled combinations for the given digits
    generateShuffledValues = (values) => {
        if (values.length === 2) {
            return [`${values[1]}${values[0]}`];
        }
        if (values.length === 3) {
            const [a, b, c] = values;
            // 5 แบบ (ไม่เอาแบบเดิม abc)
            const out = new Set([
                `${a}${c}${b}`,
                `${b}${a}${c}`,
                `${b}${c}${a}`,
                `${c}${a}${b}`,
                `${c}${b}${a}`,
            ]);
            return [...out];
        }
        return [];
    };

    getLabelForKeyid = (keyid) => {
        const setting = this.state.Dynamicsetting.find((item) => item.keyid === keyid);
        return setting ? setting.key : "Unknown";
    };
    // Helper function to generate all shuffled combinations for 2 or 3 digits
    // generateShuffledValues = (values) => {
    //     if (values.length === 2) {
    //         return [values[1] + values[0]]; // 2-digit shuffle
    //     } else if (values.length === 3) {
    //         const [a, b, c] = values;
    //         return [
    //             `${a}${c}${b}`,
    //             `${c}${a}${b}`,
    //             `${c}${b}${a}`,
    //             `${b}${c}${a}`,
    //         ]; // 3-digit shuffle
    //     }
    //     return [];
    // };

    handleClickchagetype = (e) => {
        const { Dynamicsetting } = this.state;

        const { target: { id } } = e; // ดึง id ที่กดมา
        console.log("handleClickchagetype", id);

        // กรอง Dynamicsetting ที่มี digit ตรงกับ id
        const filteredSettings = Dynamicsetting.filter(setting => setting.enabled === 1 && setting.digit === parseInt(id, 10));

        if (filteredSettings.length > 0) {
            // สุ่มเลือกตัวแรกจาก filteredSettings
            const randomSetting = filteredSettings[0]; // ถ้าอยากสุ่มจริงๆ ใช้ Math.random()

            console.log("Selected random setting:", randomSetting);
            // อัปเดต state โดยใช้ randomSetting
            this.setState({
                typename: randomSetting.keyid, // อัปเดต typename ตามที่เลือก
                numbertype: id,// กำหนด digit ที่เลือก
                type: id, // กำหนด digit ที่เลือก
            });
        } else {
            console.warn(`No settings found for digit ${id}`);
        }
    };
    formatThaiDate(dateStr) {
        if (!dateStr) return '';

        const daysThai = [
            'วันอาทิตย์',
            'วันจันทร์',
            'วันอังคาร',
            'วันพุธ',
            'วันพฤหัสบดี',
            'วันศุกร์',
            'วันเสาร์'
        ];

        const d = new Date(dateStr);
        const dayName = daysThai[d.getDay()];
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const buddhistYear2Digit = String(d.getFullYear() + 543).slice(-2);

        // console.log("datedatedatedate", `${dayName} ${day}/${month}/${buddhistYear2Digit}`)
        return `${dayName} ${day}/${month}/${buddhistYear2Digit}`;
    }
    render() {
        const {
            isHidden,
            isOpen,
            isOpenx,
            typename,
            numberSets,
            numbertype,
            isOpensend,
            isOpenxprint,
            statehuay,
            isModalOpen,
            totalItems,
            totalPrice,
            player,
            currentUser,
            usercontext,
            pricetotal,
            countdownMain
        } = this.state;
        var pricesum = 0;
        usercontext.map((Mainmenu, i) => (test = Mainmenu.Point - pricesum));
        // console.log("type", this.state.type);

        //  console.log("roomid", this.state.room)
        if (!currentUser && statehuay) {
            return (

                <>
                    {this.state.isPageLoading && (
                        <div
                            style={{
                                position: "fixed",
                                inset: 0,
                                zIndex: 9999,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "rgba(0,0,0,0.8)",
                            }}
                        >
                            <div style={{ textAlign: "center" }}>
                                <div className="loader" />
                                <div style={{ color: "#fff", marginTop: 12 }}>
                                    กำลังเข้าสู่ระบบ…
                                </div>
                            </div>
                        </div>
                    )}

                    {!this.state.isPageLoading && (

                        <>
                            {/* <div className="d-flex justify-content-between align-items-center">
                                <div className="d-flex align-items-center">
                                    <a href={`/Poyapporve/${window.location.search}`} className="reload_poy">
                                        <h4><span className="badge badge-pill badge-warning font-weight-normal">ดูโพยใหม่</span></h4>
                                    </a>
                                </div>
                                <div id="top"></div>
                                <div className="d-flex">
                                    <a href={`/numbersets/${window.location.search}`} className="btn btn-success btn-sm mr-2">
                                        <i className="fas fa-plus"></i> จัดการเลขชุด
                                    </a>
                                    <a
                                        role="button"
                                        className="btn btn-outline-secondary btn-sm text-dark btn-choke-rule"
                                        onClick={this.openModal}
                                    >
                                        กติกา
                                    </a>
                                </div>
                            </div> */}

                            <div
                                // className="p-2 w-100 bg-light main-content align-self-stretch d-flex flex-column align-items-stretch"
                                style={{ minHeight: "calc(-200px + 100vh)" }}
                            >
                                <div className="bg-lottery-header-bar text-theme-primary shadow-sm rounded p-2 px-2 xtarget col-lotto d-flex flex-row mb-0 pb-0">
                                    <div className="d-flex justify-content-between align-items-center mb-0 flex-fill choke-lotto-title">
                                        <h4 className="tanghuay-h4 col-8 p-0">
                                            {this.state.room.name}{" "}
                                            {this.state.room.drawDateKey && (
                                                <span className="badge badge-pill badge-primary-mhandee font-weight-light">
                                                    <small className="ng-star-inserted">  {this.formatThaiDate(this.state.room.drawDateKey)}</small>
                                                </span>
                                            )}
                                        </h4>
                                        <div className="choke-tanghuay-time_day col-4 p-0 ng-star-inserted" style={{ justifyContent: "right" }}>
                                            <i className="far fa-clock" />
                                            <span className="countdown-number countdown ml-1">
                                                <span
                                                    style={{ display: countdownMain.days > 0 ? "inline" : "none" }}
                                                >
                                                    {countdownMain.days} วัน<small></small>
                                                </span>
                                                {countdownMain.hours}<small>:</small>
                                                {countdownMain.minutes}<small>:</small>
                                                {countdownMain.seconds}
                                            </span>{" "}
                                        </div>
                                    </div>
                                    {/* end title -*/}
                                </div>
                                {/*- end bg content --*/}
                                <div className="row-menu-grid">
                                    <div
                                        className="d-flex flex-row justify-content-between align-items-stretch p-1 mt-1 pr-2 bg-white rounded shadow-sm flex-fill cart-item-lists"
                                        id="numpage_1"
                                    >
                                        <div
                                            style={{
                                                minWidth: isHidden ? "0px" : "35%",
                                                width: isHidden ? "0px" : "35%",
                                                opacity: isHidden ? 0 : 1,
                                                overflow: isHidden ? "hidden" : "visible",
                                                transition: "all 0.3s ease-in-out", // Smooth transition
                                            }}
                                            className="d-flex flex-column flex-fill box__play"
                                            id="show_poy_list"
                                        >
                                            {!isHidden && (
                                                <div id="hide-list-huay">
                                                    <a
                                                        className="btn-move btn-move-left mb-1"
                                                        onClick={this.toggleSidebar}
                                                    >
                                                        <span>
                                                            <i className="fas fa-chevron-circle-left"></i> ซ่อน
                                                        </span>
                                                    </a>
                                                </div>
                                            )}
                                            <div
                                                className="sidebar-huay d-flex flex-column flex-fill"
                                                id="sidebar-huay"
                                            >
                                                <button className="btn btn-light btn-sm btn-block number-sets triggerPoy"
                                                    onClick={this.toggleOpenx}
                                                >
                                                    <i className="fas fa-list-ol" /> ดึงโพย{" "}
                                                </button>
                                                <button
                                                    className="btn btn-danger btn-sm btn-block show-lists triggerPrice"
                                                    onClick={this.handleToggle}
                                                >
                                                    <i className="fas fa-edit" /> ใส่ราคา{" "}
                                                </button>
                                                <h5 className="title-huay mt-2">
                                                    <i className="fas fa-receipt" /> รายการแทง
                                                </h5>

                                                <span className="bet_num_count">
                                                    {
                                                        Object.keys(this.state)
                                                            .filter((key) => key.startsWith("ItemNumber_"))
                                                            .reduce((total, key) => total + this.state[key].length, 0)
                                                    } รายการ
                                                </span>
                                                <div className="list-huay flex-fill">
                                                    <ol className="choke-num-huay" id="show_bet_num">
                                                        {Object.keys(this.state)
                                                            .filter((k) => k.startsWith("ItemNumber_"))
                                                            .flatMap((k) => {
                                                                const items = this.state[k] || [];
                                                                if (!items.length) return [];

                                                                const keyid = k.replace("ItemNumber_", "");
                                                                const label = this.getLabelForKeyid(keyid);

                                                                return [
                                                                    // label (เหมือน <span class="ng-star-inserted">สามตัวบน</span>)
                                                                    <span key={`${k}_label`} className="ng-star-inserted">
                                                                        {label}
                                                                    </span>,

                                                                    // list items (เหมือน li.count-tang)
                                                                    ...items.map((item, index) => (
                                                                        <li key={`${k}_${index}`} className="count-tang ng-star-inserted">
                                                                            <div className="d-flex flex-row flex-grow-1">
                                                                                <div className="flex-grow-1">{item.value}</div>

                                                                                <a
                                                                                    role="button"
                                                                                    tabIndex={0}
                                                                                    onClick={() => this.handleDeleteItem(k, index)} // <-- เปลี่ยนเป็นฟังก์ชันลบของคุณ
                                                                                    onKeyDown={(e) => {
                                                                                        if (e.key === "Enter" || e.key === " ") {
                                                                                            this.handleDeleteItem(k, index);
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    <i className="fas fa-times" />
                                                                                </a>
                                                                            </div>
                                                                        </li>
                                                                    )),
                                                                ];
                                                            })}
                                                    </ol>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="sidebar-tanghuay box__play" id="page_tang">
                                            {isHidden && (
                                                <div id="show-list-huay" style={{
                                                    minWidth: !isHidden ? "0px" : "100%",
                                                    width: !isHidden ? "0px" : "100%",
                                                    transition: "all 1s", // Smooth transition
                                                }} className="d-flex justify-content-between">
                                                    <span className="btn-move bet_num_count justify-content-center rounded" />
                                                    <a onClick={this.toggleSidebar} className="btn-move btn-move-right flex-fill">
                                                        <span>
                                                            แสดง <i className="fas fa-chevron-circle-right" />
                                                        </span>
                                                    </a>
                                                </div>
                                            )}
                                            <nav>
                                                <div className="nav nav-tabs nav-pills nav-justified" id="nav-tab1" role="tablist">
                                                    <a className="nav-item nav-link p-1 active show" id="nav-keyboard-tab" data-toggle="tab" href="#nav-keyboard" role="tab" aria-controls="nav-keyboard" aria-selected="true">กดเลขเอง</a>
                                                    <a className="nav-item nav-link p-1" id="nav-panghuay-tab" data-toggle="tab" href="#nav-panghuay" role="tab" aria-controls="nav-panghuay" aria-selected="false">เลือกจากแผง</a>
                                                </div>
                                            </nav>
                                            <div className="tab-content" id="nav-tabContent">
                                                <div className="tab-pane fade active show" id="nav-keyboard" role="tabpanel" aria-labelledby="nav-keyboard-tab">
                                                    {
                                                        this.CompltelyBtnType()

                                                    }
                                                    <div
                                                        className="bg-option p-1 pb-0 mt-1 rounded box__two-option box__play setting__number"
                                                        id="2option"
                                                        style={{ display: this.state.type == 2 && this.state.typename !== '' ? "" : "none" }}
                                                    >
                                                        <i className="fas fa-bars" /> ตัวเลือกเพิ่มเติม{" "}
                                                        <div className="d-flex flex-lg-row justify-content-around align-content-stretch flex-wrap">
                                                            <div className="flex-fill">
                                                                <div className="bg-btn">
                                                                    <button
                                                                        onClick={() => this.setState(prev => ({
                                                                            option_2: prev.option_2 === "option_2_19" ? "" : "option_2_19",
                                                                            result1: "", result2: "", result3: ""
                                                                        }))}
                                                                        className={`btn btn-danger btn-sm btn-block h-100 bet_two option2btn ${this.state.option_2 === "option_2_19" ? "active" : ""
                                                                            }`}
                                                                        id="option_2_19"
                                                                    >
                                                                        19 ประตู
                                                                    </button>

                                                                </div>
                                                            </div>
                                                            <div className="flex-fill">
                                                                <div className="bg-btn">
                                                                    <button
                                                                        onClick={this.handleDoubleNumbers}
                                                                        className="btn btn-danger btn-sm btn-block h-100 bet_two"
                                                                        id="option_2_ble"
                                                                    >
                                                                        เลขเบิ้ล{" "}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="flex-fill">
                                                                <div className="bg-btn">
                                                                    <button onClick={() => this.setState(prev => ({
                                                                        option_2: prev.option_2 === "option_2_roodnha" ? "" : "option_2_roodnha",
                                                                        result1: "", result2: "", result3: ""
                                                                    }))}
                                                                        className={`btn btn-primary btn-sm btn-block h-100 bet_two option2btn ${this.state.option_2 === "option_2_roodnha" ? "active" : ""
                                                                            }`}
                                                                        id="option_2_roodnha"
                                                                    >
                                                                        รูดหน้า
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="flex-fill">
                                                                <div className="bg-btn">
                                                                    <button
                                                                        onClick={() => this.setState(prev => ({
                                                                            option_2: prev.option_2 === "option_2_roodlung" ? "" : "option_2_roodlung",
                                                                            result1: "", result2: "", result3: ""
                                                                        }))}
                                                                        className={`btn btn-primary btn-sm btn-block h-100 bet_two option2btn ${this.state.option_2 === "option_2_roodlung" ? "active" : ""
                                                                            }`}
                                                                        id="option_2_roodlung"
                                                                    >
                                                                        รูดหลัง
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="flex-fill">
                                                                <div className="bg-btn">
                                                                    <button
                                                                        onClick={this.handleDoubleNumbers_00_49}
                                                                        className="btn btn-info btn-sm btn-block h-100 bet_two"
                                                                        id="option_2_low"
                                                                    >
                                                                        สองตัวต่ำ{" "}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="flex-fill">
                                                                <div className="bg-btn">
                                                                    <button
                                                                        onClick={this.handleDoubleNumbers_50_99}
                                                                        className="btn btn-info btn-sm btn-block h-100 bet_two"
                                                                        id="option_2_high"
                                                                    >
                                                                        สองตัวสูง{" "}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="flex-fill">
                                                                <div className="bg-btn">
                                                                    <button
                                                                        onClick={this.handleOddNumbers}
                                                                        className="btn btn-success btn-sm btn-block h-100 bet_two"
                                                                        id="option_2_odd"
                                                                    >
                                                                        สองตัวคี่{" "}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="flex-fill">
                                                                <div className="bg-btn">
                                                                    <button
                                                                        onClick={this.handleEvenNumbers}
                                                                        className="btn btn-success btn-sm btn-block h-100 bet_two"
                                                                        id="option_2_even"
                                                                    >
                                                                        สองตัวคุ่{" "}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="w-100 bg-danger px-1 pb-1 text-center border my-1">
                                                        <p className="border-bottom mb-1" ><small style={{ color: "white" }}>รายการที่เลือก</small></p>
                                                        <div id="resultoption">
                                                            {
                                                                this.CompltelyType()
                                                            }
                                                        </div>
                                                    </div>
                                                    {
                                                        this.CompltelyPad()
                                                    }
                                                </div>

                                                <div className="tab-pane fade" id="nav-panghuay" role="tabpanel" aria-labelledby="nav-panghuay-tab">
                                                    <div className="w-100 p-1">
                                                        <ul className="nav nav-pills nav-justified mb-2" id="number-tab" role="tablist">
                                                            <li className="nav-item">
                                                                <a className="nav-link p-1 py-3 btn-outline-red active show" id="3" onClick={(e) => this.handleClickchagetype(e, 3)} data-toggle="pill" href="#pills-3" role="tab" aria-controls="3" aria-selected="true">สามตัว</a>
                                                            </li>
                                                            <li className="nav-item">
                                                                <a className="nav-link p-1 py-3 btn-outline-blue" id="2" onClick={(e) => this.handleClickchagetype(e, 2)} data-toggle="pill" href="#pills-2" role="tab" aria-controls="2" aria-selected="false">สองตัว</a>
                                                            </li>
                                                        </ul>
                                                        <div className="row mb-2 py-3 mx-0 bg-dark rounded">
                                                            <div className="col pr-1">
                                                                <font color="#FFCC00"><i className="fas fa-exclamation-circle"></i> สีเทา= เลขนี้มีคนแทงเยอะยังไม่สามารถซื้อได้</font>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="tab-content" id="pills-tabContent-number">
                                                        <div className="row m-0">
                                                            <div className="col-12 col-sm-12 col-md-8 p-1">
                                                                <div className="input-group input-group-sm">
                                                                    <input type="text" className="form-control" placeholder="ค้นหาตัวเลข" aria-label="ค้นหาตัวเลข" aria-describedby="button-addon2" id="search-number2" />
                                                                    <div className="input-group-append">
                                                                        <button className="btn btn-outline-secondary" type="button" id="button-addon2"><i className="fas fa-search"></i></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-12 col-sm-12 col-md-4 p-1">
                                                                <button href="" className="btn btn-outline-secondary btn-block btn-sm btn-panghuay py-2" id="shuffle_2">
                                                                    <i className="fas fa-random"></i>กลับตัวเลข
                                                                </button>
                                                            </div>
                                                        </div>
                                                        <div className="tab-pane fade active show" id="pills-3" role="tabpanel" aria-labelledby="pills-3-tab">
                                                            <div className="row m-0">
                                                                {this.state.Dynamicsetting
                                                                    .filter(option => option.enabled === 1 && option.digit === 3) // Filter for enabled options with 3 digits
                                                                    .map((setting, index) => (
                                                                        <div key={index} className="col-6 p-1">
                                                                            <div className="row-btn-tanghuay">
                                                                                <button
                                                                                    className={`btn btn-outline-red btn-sm btn-block h-100 d-flex justify-content-between align-items-center btn-panghuay bet_three ${this.state.typename === setting.keyid ? "active" : ""}`}
                                                                                    id={setting.keyid}
                                                                                    onClick={() => this.handleClickchagetypemain(setting)}
                                                                                >
                                                                                    <div className="bg-danger text-white flex-fill">
                                                                                        <i>{setting.key}</i>
                                                                                    </div>
                                                                                    <div className="text-center">{setting.value}</div>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}
                                                            </div>
                                                        </div>
                                                        <div className="tab-pane fade" id="pills-2" role="tabpanel" aria-labelledby="pills-2-tab">
                                                            <div className="row m-0">
                                                                {this.state.Dynamicsetting
                                                                    .filter(option => option.enabled === 1 && option.digit === 2) // Filter for enabled options with 2 digits
                                                                    .map((setting, index) => (
                                                                        <div key={index} className="col-6 p-1">
                                                                            <div className="row-btn-tanghuay">
                                                                                <button
                                                                                    className={`btn btn-outline-blue btn-sm btn-block h-100 d-flex justify-content-between align-items-center btn-panghuay bet_two ${this.state.typename === setting.keyid ? "active" : ""}`}
                                                                                    id={setting.keyid}
                                                                                    onClick={() => this.handleClickchagetypemain(setting)}
                                                                                >
                                                                                    <div className="bg-primary text-white flex-fill">
                                                                                        <i>{setting.key}</i>
                                                                                    </div>
                                                                                    <div className="text-center">{setting.value}</div>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    ))}

                                                                <div className="row m-0">
                                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-4 pt-1 pb-0 px-0 px-sm-0 px-md-2">
                                                                        <div id="ninetybtn" className="overlay"></div>

                                                                        <span className="d-block d-sm-block d-md-inline">19 ประตู</span>
                                                                        <div className="btn-group btn-group-sm d-flex" role="group">
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="0" data-option="option_2_19">
                                                                                    <input type="checkbox" name="ninety" value="0" />
                                                                                    0
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="1" data-option="option_2_19">
                                                                                    <input type="checkbox" name="ninety" value="1" />
                                                                                    1
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="2" data-option="option_2_19">
                                                                                    <input type="checkbox" name="ninety" value="2" />
                                                                                    2
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="3" data-option="option_2_19">
                                                                                    <input type="checkbox" name="ninety" value="3" />
                                                                                    3
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="4" data-option="option_2_19">
                                                                                    <input type="checkbox" name="ninety" value="4" />
                                                                                    4
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="5" data-option="option_2_19">
                                                                                    <input type="checkbox" name="ninety" value="5" />
                                                                                    5
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="6" data-option="option_2_19">
                                                                                    <input type="checkbox" name="ninety" value="6" />
                                                                                    6
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="7" data-option="option_2_19">
                                                                                    <input type="checkbox" name="ninety" value="7" />
                                                                                    7
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="8" data-option="option_2_19">
                                                                                    <input type="checkbox" name="ninety" value="8" />
                                                                                    8
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="9" data-option="option_2_19">
                                                                                    <input type="checkbox" name="ninety" value="9" />
                                                                                    9
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-4 pt-1 pb-0 px-0 px-sm-0 px-md-2">
                                                                        <div id="roodfrontbtn" className="overlay"></div>
                                                                        <span className="d-block d-sm-block d-md-inline">รูดหน้า</span>
                                                                        <div className="btn-group btn-group-sm d-flex" role="group">
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="0" data-option="option_2_roodnha">
                                                                                    <input type="checkbox" name="roodfront" value="0" />
                                                                                    0
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="1" data-option="option_2_roodnha">
                                                                                    <input type="checkbox" name="roodfront" value="1" />
                                                                                    1
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="2" data-option="option_2_roodnha">
                                                                                    <input type="checkbox" name="roodfront" value="2" />
                                                                                    2
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="3" data-option="option_2_roodnha">
                                                                                    <input type="checkbox" name="roodfront" value="3" />
                                                                                    3
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="4" data-option="option_2_roodnha">
                                                                                    <input type="checkbox" name="roodfront" value="4" />
                                                                                    4
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="5" data-option="option_2_roodnha">
                                                                                    <input type="checkbox" name="roodfront" value="5" />
                                                                                    5
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="6" data-option="option_2_roodnha">
                                                                                    <input type="checkbox" name="roodfront" value="6" />
                                                                                    6
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="7" data-option="option_2_roodnha">
                                                                                    <input type="checkbox" name="roodfront" value="7" />
                                                                                    7
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="8" data-option="option_2_roodnha">
                                                                                    <input type="checkbox" name="roodfront" value="8" />
                                                                                    8
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="9" data-option="option_2_roodnha">
                                                                                    <input type="checkbox" name="roodfront" value="9" />
                                                                                    9
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-12 col-sm-12 col-md-12 col-lg-4 pt-1 pb-0 px-0 px-sm-0 px-md-2">
                                                                        <div id="roodbackbtn" className="overlay"></div>
                                                                        <span className="d-block d-sm-block d-md-inline">รูดหลัง</span>
                                                                        <div className="btn-group btn-group-sm d-flex" role="group">
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="0" data-option="option_2_roodlung">
                                                                                    <input type="checkbox" name="roodback" value="0" />
                                                                                    0
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="1" data-option="option_2_roodlung">
                                                                                    <input type="checkbox" name="roodback" value="1" />
                                                                                    1
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="2" data-option="option_2_roodlung">
                                                                                    <input type="checkbox" name="roodback" value="2" />
                                                                                    2
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="3" data-option="option_2_roodlung">
                                                                                    <input type="checkbox" name="roodback" value="3" />
                                                                                    3
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="4" data-option="option_2_roodlung">
                                                                                    <input type="checkbox" name="roodback" value="4" />
                                                                                    4
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="5" data-option="option_2_roodlung">
                                                                                    <input type="checkbox" name="roodback" value="5" />
                                                                                    5
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="6" data-option="option_2_roodlung">
                                                                                    <input type="checkbox" name="roodback" value="6" />
                                                                                    6
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="7" data-option="option_2_roodlung">
                                                                                    <input type="checkbox" name="roodback" value="7" />
                                                                                    7
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="8" data-option="option_2_roodlung">
                                                                                    <input type="checkbox" name="roodback" value="8" />
                                                                                    8
                                                                                </label>
                                                                            </div>
                                                                            <div className="btn-group-toggle d-inline flex-fill" data-toggle="buttons">
                                                                                <label className="btn btn-outline-secondary btn-rood btn-sm mb-1 panghuay_option_2" data-id="9" data-option="option_2_roodlung">
                                                                                    <input type="checkbox" name="roodback" value="9" />
                                                                                    9
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="w-100 border-top my-1"></div>
                                                            </div>
                                                        </div>
                                                        <div className="tab-content" id="numlist-tabContent1">
                                                            <div className="text-center tab-pane fade show active" id="pills-000" role="tabpanel" aria-labelledby="pills-000-tab">
                                                                {this.createNumber()}

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <b>
                                                <b>
                                                    <div className="w-100">
                                                        <div className="row mb-2 py-3 mx-0 bg-dark rounded">
                                                            <div className="col pr-1">
                                                                <button className="btn btn-light btn-sm btn-block number-sets border triggerPoy" onClick={this.toggleOpenx}>
                                                                    <i className="fas fa-list-ol"></i>ดึงโพย
                                                                </button>
                                                            </div>
                                                            <div className="col pl-1">
                                                                <button onClick={this.handleToggle} className="btn btn-danger btn-sm btn-block show-lists triggerPrice">
                                                                    <i className="fas fa-edit"></i>ใส่ราคา
                                                                </button>
                                                            </div>
                                                        </div>

                                                    </div>
                                                    {
                                                        this.CompltelyRule()
                                                    }
                                                </b>
                                            </b>
                                        </div>
                                        <b>
                                            <b>{/*----------end sidebar tanghuay --------------*/}</b>
                                        </b>
                                    </div>

                                </div>
                                <b>
                                    <b>
                                        <div
                                            className={`modal fade ${isModalOpen ? "show" : ""}`}
                                            id="rule-yeekee"
                                            tabIndex={-1}
                                            role="dialog"
                                            aria-labelledby="rule-yeekee"
                                            style={{ display: isModalOpen ? "block" : "none" }}
                                            aria-hidden={!isModalOpen}
                                        >
                                            <div className="modal-dialog modal-lg" role="document">
                                                <div className="modal-content" style={{ borderRadius: 10 }}>
                                                    <div className="modal-header bg-danger text-white">
                                                        <h5 className="modal-title">กติกา</h5>
                                                        <button
                                                            type="button"
                                                            className="text-white close"
                                                            data-dismiss="modal"
                                                            aria-label="Close"
                                                            onClick={this.closeModal}
                                                        >
                                                            <span aria-hidden="true">×</span>
                                                        </button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="contain">
                                                            <div dangerouslySetInnerHTML={{ __html: this.state.rulehtml }} />
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button
                                                            type="button"
                                                            onClick={this.closeModal}
                                                            className="btn btn-danger"
                                                            data-dismiss="modal"
                                                        >
                                                            ฉันเข้าใจและยอมรับ
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="price"
                                            style={{ zIndex: 200 }}
                                            className={`pagemodal-wrapper ${isOpen ? "open" : ""}`}
                                        >
                                            <div className="container">
                                                <div className="pagemodal">
                                                    <div className="head">
                                                        <i className="fas fa-edit" /> ใส่ราคา{" "}
                                                        <span className="badge badge-pill badge-dark" id="total_poy_list">
                                                            {totalItems || 0} รายการ
                                                        </span>
                                                        <a className="btn-close triggerPrice"
                                                            href="javascript:;"
                                                            onClick={this.handleClose} />
                                                    </div>
                                                    <table className="table table-striped table-hover table-sm d-none"
                                                        id="model_poy_option"
                                                    >
                                                        <tbody>
                                                            <tr>
                                                                <th className="align-middle">#</th>
                                                                <th colSpan={2} className="text-danger" style={{ fontSize: 16 }}>
                                                                    {"{"}bet-option-name{"}"}
                                                                </th>
                                                                <th className="text-center text-primary" style={{ fontSize: 16 }}>
                                                                    อัตราคูณ
                                                                </th>
                                                                <th colSpan={2} className="text-dark" style={{ fontSize: 16 }}>
                                                                    เรทชนะ
                                                                </th>
                                                            </tr>
                                                            <tr id="model_poy_list" className="{is-duplicate-class}">
                                                                <td className="align-middle text-center table-secondary">
                                                                    {"{"}bet_cnt{"}"}.
                                                                </td>
                                                                <td
                                                                    className="align-middle text-center bg-success text-white font-weight-bold {is-duplicate-class}"
                                                                    style={{ fontSize: 16 }}
                                                                >
                                                                    {"{"}pl_number{"}"}
                                                                </td>
                                                                <td className="align-middle text-center">
                                                                    <input
                                                                        type="tel"
                                                                        id="pl_price_{poy-list-id}"
                                                                        defaultValue="{pl-price}"
                                                                        placeholder="ระบุจำนวนเงิน"
                                                                        minLength={1}
                                                                        maxLength={6}
                                                                        pattern="[0-9]*"
                                                                        className="form-control bg-black text-gold border-right-gold pl_price"
                                                                        oninput="this.value=this.value.replace(/[^0-9]/g,'')"
                                                                    />
                                                                </td>
                                                                <td
                                                                    className="align-middle text-center"
                                                                    id="model_poy_list_multiply"
                                                                >
                                                                    {"{"}bet_multiply{"}"}
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        id="model_poy_list_win"
                                                                        defaultValue="{pl-win}฿"
                                                                        readOnly=""
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <div className="btn btn-danger" id="del_pl_{poy-list-id}">
                                                                        <i className="fas fa-trash-alt" />
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <div className="content">
                                                        <div className="dynamic-content" style={{
                                                            overflowY: 'auto',
                                                            overflowX: 'hidden',
                                                            paddingBottom: 175,
                                                            height: isMobile ? 600 : 719
                                                        }} >
                                                            <div id="poy_list">
                                                                {Object.keys(this.state)
                                                                    .filter((key) => key.startsWith("ItemNumber_"))
                                                                    .map((key) => {
                                                                        const items = this.state[key];
                                                                        const keyid = key.replace("ItemNumber_", "");
                                                                        const setting = this.state.Dynamicsetting.find((s) => s.keyid === keyid);
                                                                        if (!setting || items.length === 0) return null;

                                                                        const valueCounts = items.reduce((counts, item) => {
                                                                            counts[item.value] = (counts[item.value] || 0) + 1;
                                                                            return counts;
                                                                        }, {});

                                                                        return (
                                                                            <table
                                                                                key={key}
                                                                                className="table table-striped table-hover table-sm"
                                                                                id={`poy_option_${keyid}`}
                                                                                // margin-bottom ไม่ต้องโตตาม length แล้ว ให้คงที่พอดีตา
                                                                                style={{ marginBottom: 16 }}
                                                                            >
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th className="align-middle">#</th>
                                                                                        <th colSpan={2} className="text-danger" style={{ fontSize: 16 }}>
                                                                                            {setting.key}
                                                                                        </th>
                                                                                        <th className="text-center text-primary" style={{ fontSize: 16 }}>
                                                                                            อัตราคูณ
                                                                                        </th>
                                                                                        <th colSpan={2} className="text-dark" style={{ fontSize: 16 }}>
                                                                                            เรทชนะ
                                                                                        </th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {items.map((item, index) => {
                                                                                        // หา limitSetting (ตรวจสอบ property access ให้ถูก ถ้า Settings เป็น array อาจต้องเปลี่ยน)
                                                                                        const limitSetting = this.state.limitNumberSettings.find(
                                                                                            (limit) => limit.number === item.value && limit.Settings?.keyid === keyid
                                                                                        );

                                                                                        // console.log("limitSetting",items)
                                                                                        // อ่านค่า payoutPerBaht จาก DB แบบปลอดภัย
                                                                                        const rawPpb = limitSetting?.payoutPerBaht;
                                                                                        const ppb = (rawPpb === null || rawPpb === undefined) ? NaN : Number(rawPpb);

                                                                                        // ถ้า setting.value ควรเป็นตัวเลข ให้แปลงก่อน (safety)
                                                                                        const baseRate = Number(setting.value) || 0;

                                                                                        let computedPayout; // ผลลัพธ์เป็น number
                                                                                        if (!Number.isFinite(ppb)) {
                                                                                            // ไม่ได้ตั้ง "อั้นจ่าย" => ใช้เรทเต็มตามขั้นบันได/ค่าเดิม
                                                                                            computedPayout = baseRate;
                                                                                        } else if (ppb === 0) {
                                                                                            // 0 = ปิดรับเลขนี้
                                                                                            computedPayout = 0;
                                                                                        } else {
                                                                                            // "อั้นจ่ายหาร %" = เปอร์เซ็นต์ที่จ่าย
                                                                                            // 50 => จ่าย 50% (1000*0.5=500), 100 => จ่ายเต็ม 100% (1000)
                                                                                            computedPayout = Math.floor(baseRate * (ppb / 100));
                                                                                        }

                                                                                        // สุดท้าย: ถ้าต้องการ string ให้ทำ .toString(), ปกติเก็บเป็น number จะดีกว่า
                                                                                        const payoutPerBaht = computedPayout;

                                                                                        return (
                                                                                            <tr
                                                                                                key={`${key}_${index}`}
                                                                                                className={`align-middle text-center font-weight-bold ${limitSetting ? "multiply-change" : ""
                                                                                                    } ${valueCounts[item.value] > 1 ? "number-is-duplicate-active" : ""}`}
                                                                                            >
                                                                                                <td className="align-middle text-center table-secondary">{index + 1}.</td>
                                                                                                <td className="bg-success text-white" style={{ fontSize: 16 }}>
                                                                                                    {item.value}
                                                                                                </td>
                                                                                                <td className="align-middle text-center">
                                                                                                    <input
                                                                                                        type="tel"
                                                                                                        id={`pl_price_${item.index}`}
                                                                                                        value={item.price || ""}
                                                                                                        placeholder="ระบุจำนวนเงิน"
                                                                                                        minLength={1}
                                                                                                        maxLength={6}
                                                                                                        pattern="[0-9]*"
                                                                                                        className="form-control bg-black text-gold border-right-gold pl_price"
                                                                                                        onChange={(e) => this.handlePriceChange(e, key, index)}
                                                                                                    />
                                                                                                </td>
                                                                                                <td className="align-middle text-center">{payoutPerBaht}</td>
                                                                                                <td>
                                                                                                    <input
                                                                                                        type="text"
                                                                                                        className="form-control"
                                                                                                        value={`${(item.price || 0) * payoutPerBaht}฿`}
                                                                                                        readOnly
                                                                                                    />
                                                                                                </td>
                                                                                                <td>
                                                                                                    <button
                                                                                                        className="btn btn-danger"
                                                                                                        onClick={() => this.handleDeleteItem(key, index)}
                                                                                                    >
                                                                                                        <i className="fas fa-trash-alt" />
                                                                                                    </button>
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    })}
                                                                                </tbody>
                                                                            </table>
                                                                        );
                                                                    })}
                                                            </div>
                                                            <div className="mb-3" >
                                                                <div className="row px-3">
                                                                    <div className="col-6 ml-0">
                                                                        <button
                                                                            onClick={this.handleViewDuplicate}
                                                                            className="btn btn-secondary btn-block"
                                                                            id="view_duplicate"
                                                                        >
                                                                            <i className="fas fa-search" /> ดูเลขซ้ำ{" "}
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-6 mr-0">
                                                                        <button className="btn btn-dark btn-block" onClick={this.handleDeleteDuplicate} id="delete_duplicate">
                                                                            <i className="fas fa-eraser" /> ตัดเลขซ้ำ{" "}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                                <hr className="mb-0" />
                                                                <div className="row px-3">
                                                                    <div className="col-6 align-middle text-center text-success pl-4 pt-2 pr-0">
                                                                        ราคา<b>"เท่ากัน"</b>ทั้งหมด
                                                                        <br />
                                                                        <div className="input-group mb-3">
                                                                            <input
                                                                                type="tel"
                                                                                className="form-control"
                                                                                placeholder="ใส่ราคา"
                                                                                aria-label="ใส่ราคา"
                                                                                aria-describedby="button-addon2"
                                                                                id="set_all_price"
                                                                                onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} // Prevent non-numeric input
                                                                                onChange={this.handleSetAllPrices}
                                                                            />
                                                                            <div className="input-group-append">
                                                                                <button
                                                                                    className="btn btn-outline-success"
                                                                                    type="button"
                                                                                    id="button-addon2"
                                                                                >
                                                                                    <i className="fas fa-plus" />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-6 align-middle text-center pr-1 pl-0">
                                                                        <div className="box__chip-lists d-flex justify-content-around align-items-center flex-wrap p-2">
                                                                            {[5, 10, 20, 50, 100].map((amount) => (
                                                                                <div
                                                                                    role="button"
                                                                                    key={amount}
                                                                                    className="price btn-price"
                                                                                    data-id={amount}
                                                                                    onClick={(e) => this.handleSetAllPricesxx(e)}
                                                                                >
                                                                                    {amount} ฿
                                                                                </div>
                                                                            ))}
                                                                        </div>

                                                                    </div>
                                                                </div>
                                                                <div className="row px-3 pb-1 mb-1">
                                                                    <div className="col-6 bg-primary text-white text-center p-1 mb-3">
                                                                        <span className="badge badge-light">ยอดเครดิตคงเหลือ</span>
                                                                        <br />
                                                                        <span className="thb" data-id="credit_balance">
                                                                            {(player.balance || 0).toFixed(2)}฿
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-6 bg-danger text-white text-center p-1 mb-3">
                                                                        <span className="badge badge-light">รวมยอดแทง</span>
                                                                        <br />
                                                                        <span className="thb total_price">{totalPrice || 0}</span>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <button onClick={this.handleClickClear} className="btn btn-light btn-block" id="reset_poy">
                                                                            <i className="fas fa-ban" /> ยกเลิกทั้งหมด{" "}
                                                                        </button>
                                                                    </div>
                                                                    <div className="col-6">
                                                                        <button onClick={this.sendpoy} className="btn btn-success btn-block triggerSendpoy">
                                                                            <i className="fas fa-check" /> ส่งโพย{" "}
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>



                                                </div>
                                            </div>
                                        </div>
                                        <div id="poy" className={`pagemodal-wrapper ${isOpenx ? "open" : ""}`}>
                                            <div className="container">
                                                <div className="pagemodal">
                                                    <div className="head">
                                                        <i className="fas fa-list-ol" /> เลขชุด - ดึงโพย{" "}
                                                        <a
                                                            role="button"
                                                            className="btn-close triggerPoy"
                                                            onClick={this.toggleModal}
                                                        />
                                                    </div>
                                                    <div className="content">
                                                        <div className="content-scroll p-2 p-md-3">
                                                            {/* Header */}
                                                            <div className="d-flex align-items-center justify-content-between mb-2">
                                                                <div className="d-flex align-items-center">
                                                                    <h5 className="mb-0 font-weight-bold text-dark">เลขชุด</h5>
                                                                    <span className="badge badge-pill badge-info ml-2">
                                                                        {Array.isArray(numberSets) ? numberSets.length : 0}
                                                                    </span>
                                                                </div>

                                                                <div style={{ maxWidth: 260 }} className="w-100">
                                                                    <input
                                                                        className="form-control form-control-sm"
                                                                        placeholder="ค้นหาชื่อชุด/เลข..."
                                                                        value={this.state.searchSetText || ''}
                                                                        onChange={(e) => this.setState({ searchSetText: e.target.value })}
                                                                    />
                                                                </div>
                                                            </div>

                                                            {/* Tabs (เผื่ออนาคตมีหลายแท็บ) */}
                                                            <ul id="poytab" className="nav nav-tabs" role="tablist">
                                                                <li className="nav-item w-50 text-center">
                                                                    <a className="nav-link mysetnumber active" href="#poy1" role="tab" data-toggle="tab">
                                                                        เลขชุด
                                                                    </a>
                                                                </li>
                                                            </ul>

                                                            <div className="tab-content">
                                                                <div role="tabpanel" className="tab-pane active" id="poy1">
                                                                    <div className="table-responsive mt-2">
                                                                        <table className="table table-striped table-hover table-sm mb-0" id="numfavorite">
                                                                            <thead className="thead-sticky">
                                                                                <tr className="bg-info text-light">
                                                                                    <th className="align-middle text-center" style={{ width: 160 }}>ชื่อชุด</th>
                                                                                    <th className="align-middle text-center" style={{ width: 170 }}>เวลาที่สร้าง</th>
                                                                                    <th className="align-middle">เลข</th>
                                                                                    <th className="align-middle text-right" style={{ width: 80 }}>เลือก</th>
                                                                                </tr>
                                                                            </thead>

                                                                            <tbody>
                                                                                {(() => {
                                                                                    const list = Array.isArray(numberSets) ? numberSets : [];
                                                                                    const q = (this.state.searchSetText || '').trim();

                                                                                    const filtered = !q
                                                                                        ? list
                                                                                        : list.filter((set) => {
                                                                                            const name = (set.poyname || '').toString();
                                                                                            const nums = Array.isArray(set.poyNumbers)
                                                                                                ? set.poyNumbers.map((p) => String(p.number)).join(',')
                                                                                                : '';
                                                                                            return (name + ' ' + nums).toLowerCase().includes(q.toLowerCase());
                                                                                        });

                                                                                    if (filtered.length === 0) {
                                                                                        return (
                                                                                            <tr>
                                                                                                <td colSpan={4} className="text-center text-muted py-4">
                                                                                                    ไม่พบเลขชุด
                                                                                                </td>
                                                                                            </tr>
                                                                                        );
                                                                                    }

                                                                                    return filtered.map((set) => (
                                                                                        <tr key={set._id} style={{ verticalAlign: 'middle' }}>
                                                                                            <td className="text-center font-weight-bold text-dark">
                                                                                                {set.poyname || 'ไม่ระบุชื่อ'}
                                                                                            </td>

                                                                                            <td className="text-center text-muted" style={{ fontSize: 13 }}>
                                                                                                {new Intl.DateTimeFormat('th-TH', {
                                                                                                    day: '2-digit',
                                                                                                    month: '2-digit',
                                                                                                    year: 'numeric',
                                                                                                    hour: '2-digit',
                                                                                                    minute: '2-digit',
                                                                                                    hour12: false
                                                                                                }).format(new Date(set.createdAt))}
                                                                                            </td>

                                                                                            <td style={{ fontSize: 13 }}>
                                                                                                {Array.isArray(set.poyNumbers) && set.poyNumbers.length > 0
                                                                                                    ? set.poyNumbers.map((poy) => `${poy.number}`).join(', ')
                                                                                                    : <span className="text-muted">ไม่มีตัวเลข</span>}
                                                                                            </td>

                                                                                            <td className="text-right">
                                                                                                <button
                                                                                                    className="btn btn-success btn-sm"
                                                                                                    onClick={() => this.handleSelectSet(set._id)}
                                                                                                    title="เลือกชุดนี้"
                                                                                                    style={{ borderRadius: 10, width: 38, height: 32 }}
                                                                                                >
                                                                                                    <i className="fas fa-check" />
                                                                                                </button>
                                                                                            </td>
                                                                                        </tr>
                                                                                    ));
                                                                                })()}
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {/* <div className="content">
                                                        <div className="content-scroll">
                                                            <ul id="poytab" className="nav nav-tabs" role="tablist">
                                                                <li className="nav-item w-50 text-center">
                                                                    <a
                                                                        className="nav-link mysetnumber active"
                                                                        href="#poy1"
                                                                        role="tab"
                                                                        data-toggle="tab"
                                                                    >
                                                                        เลขชุด
                                                                    </a>
                                                                </li>

                                                            </ul>
                                                            <div className="tab-content">
                                                                <div
                                                                    role="tabpanel"
                                                                    className="tab-pane text-center active"
                                                                    id="poy1"
                                                                >
                                                                    <table
                                                                        className="table table-striped table-sm"
                                                                        id="numfavorite"
                                                                    >
                                                                        <tbody>
                                                                            <tr className="bg-info text-light">
                                                                                <th className="align-middle text-center">ชื่อชุด</th>
                                                                                <th className="align-middle text-center">เวลาที่สร้าง</th>
                                                                                <th className="align-middle text-center">เลข</th>
                                                                                <th className="align-middle text-right" />
                                                                            </tr>
                                                                            {numberSets.map((set) => (
                                                                                <tr key={set._id}>
                                                                                    <td>{set.poyname || "ไม่ระบุชื่อ"}</td>
                                                                                    <td>
                                                                                        {new Intl.DateTimeFormat("th-TH", {
                                                                                            day: "2-digit",
                                                                                            month: "2-digit",
                                                                                            year: "numeric",
                                                                                            hour: "2-digit",
                                                                                            minute: "2-digit",
                                                                                            hour12: false,
                                                                                        }).format(new Date(set.createdAt))}
                                                                                    </td>
                                                                                    <td>
                                                                                        {Array.isArray(set.poyNumbers) && set.poyNumbers.length > 0
                                                                                            ? set.poyNumbers.map((poy) => `${poy.number}`).join(", ")
                                                                                            : "ไม่มีตัวเลข"}
                                                                                    </td>
                                                                                    <td className="text-right">
                                                                                        <button
                                                                                            className="btn btn-outline-success btn-sm"
                                                                                            onClick={() => this.handleSelectSet(set._id)}
                                                                                        >
                                                                                            <i className="fas fa-check" />
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            ))}

                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </div>
                                            </div>
                                        </div>
                                        <div id="sendpoy" style={{ zIndex: 201 }} className={`pagemodal-wrapper ${isOpensend ? "open" : ""}`}>
                                            <div className="container">
                                                <div className="pagemodal">
                                                    <div className="head bg-success">
                                                        <i className="fas fa-check-circle" /> ยืนยันคำสั่งซื้อ{" "}
                                                        <a className="btn-close triggerSendpoy" onClick={this.closesendpoy} />
                                                    </div>
                                                    <div className="content">
                                                        <div
                                                            className="content-scroll p-2"
                                                            style={{
                                                                flex: "1 1 auto",
                                                                height: "calc(100% - 200px)",
                                                                overflowY: "auto",
                                                                transition: "height .3s ease",
                                                            }}
                                                        >
                                                            {/* ====== Order Summary ====== */}
                                                            <div className="border pb-2 mb-2">
                                                                <div className="row p-0 m-0">
                                                                    <div className="col-7 py-1 bg-dark d-flex align-items-center">
                                                                        {!!this.state.logoimg && (
                                                                            <img
                                                                                src={this.state.logoimg}
                                                                                alt="logo"
                                                                                width={150}
                                                                                className="align-middle"
                                                                            />
                                                                        )}
                                                                    </div>

                                                                    <div className="col-5 py-1 pl-0 bg-dark text-white d-flex justify-content-end align-items-center">
                                                                        <h4 className="hbill mb-0">ใบสั่งซื้อ</h4>
                                                                    </div>

                                                                    {/* ซ้าย: ชื่อหวย + งวด */}
                                                                    <div className="col-7 col-md-8 pl-2 pt-2">
                                                                        <table className="table table-sm table-responsive">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td colSpan={2} className="border-top-0">
                                                                                        <h5 id="pre_confirm_name" className="hhuay bet_name">
                                                                                            {this.state.room?.name || "-"}
                                                                                        </h5>
                                                                                    </td>
                                                                                </tr>

                                                                                <tr className="border">
                                                                                    <td className="table-secondary">
                                                                                        <i className="far fa-clock" />
                                                                                    </td>
                                                                                    <td>
                                                                                        <b id="pre_confirm_round" className="hhuay_round bet_round">
                                                                                            {/* ถ้าคุณมีฟังก์ชัน formatThaiDate อยู่แล้ว ใช้อันนี้เลย */}
                                                                                            {this.formatThaiDate?.(this.state.room?.drawDateKey) ||
                                                                                                (this.state.room?.drawDateKey || "-")}
                                                                                        </b>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                    {/* ขวา: วันที่ */}
                                                                    <div className="col-5 col-md-4 pl-0 pt-2">
                                                                        <table className="table table-sm table-bordered">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left table-secondary">วันที่</td>
                                                                                    <td className="text-left">
                                                                                        {new Date().toLocaleDateString("th-TH", {
                                                                                            year: "numeric",
                                                                                            month: "2-digit",
                                                                                            day: "2-digit",
                                                                                        })}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>

                                                                    {/* ยอดรวม */}
                                                                    <div className="col-12 py-2 text-center table-success border border-success border-right-0 border-left-0">
                                                                        <span>ยอดเดิมพันทั้งหมด :</span>{" "}
                                                                        <span className="font-weight-bold text-success thb total_price">
                                                                            {this.state.totalPrice ?? 0} ฿
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* ====== Bet Details (เหมือน DOM เดิม: 1 item = 1 row) ====== */}
                                                            <div className="col-12 py-3">
                                                                {Object.keys(this.state)
                                                                    .filter((k) => k.startsWith("ItemNumber_"))
                                                                    .map((k) => {
                                                                        const items = this.state[k] || [];
                                                                        const keyid = k.replace("ItemNumber_", "");
                                                                        const setting = (this.state.Dynamicsetting || []).find(
                                                                            (s) => s.keyid === keyid
                                                                        );

                                                                        if (!setting || items.length === 0) return null;

                                                                        return (
                                                                            <div key={k} id="model_pre_confirm" className="card card-huay ng-star-inserted">
                                                                                <div className="card-header card-header-sm">
                                                                                    <div className="row">
                                                                                        <div className="col-6 font-weight-bold text-success">
                                                                                            {setting.key}
                                                                                        </div>
                                                                                        <div className="col-3">จ่าย</div>
                                                                                        <div className="col-3 text-right">ราคา</div>
                                                                                    </div>
                                                                                </div>

                                                                                <div className="card-body card-body-sm">
                                                                                    {items.map((item, index) => (
                                                                                        <div key={`${k}_${index}`} className="row">
                                                                                            <div className="col-3">
                                                                                                {index + 1}.
                                                                                                {item.status === "limit" && (
                                                                                                    <span className="text-danger ml-2">
                                                                                                        <i className="fas fa-times-circle" /> ไม่รับ
                                                                                                    </span>
                                                                                                )}
                                                                                            </div>

                                                                                            <div className="col-3">{item.value || "-"}</div>

                                                                                            <div className="col-3">
                                                                                                {item.payout != null ? item.payout : setting.value}
                                                                                            </div>

                                                                                            <div className="col-3 text-right thb">
                                                                                                {item.status === "limit" ? "0 ฿" : `${item.price ?? 0} ฿`}
                                                                                            </div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                            </div>

                                                            {/* placeholder ตาม DOM เดิม */}
                                                            <div id="pl_confirm" className="col-12 py-3" />
                                                        </div>

                                                        {/* ====== Footer ====== */}
                                                        <div className="fixbot p-2">
                                                            {!this.state.isConfirmed ? (
                                                                <>
                                                                    <textarea
                                                                        name="note"
                                                                        id="note"
                                                                        rows={2}
                                                                        placeholder="📝บันทึกช่วยจำ"
                                                                        className="form-control"
                                                                        value={this.state.note || ""}
                                                                        onChange={(e) => this.setState({ note: e.target.value })}
                                                                    />
                                                                    <hr className="mb-2" />
                                                                    <div className="row">
                                                                        <div className="col-6">
                                                                            <button className="btn btn-light btn-block" onClick={this.closesendpoy}>
                                                                                <i className="fas fa-chevron-left" /> กลับไปแก้ไข
                                                                            </button>
                                                                        </div>
                                                                        <div className="col-6" id="sendpoy_btn">
                                                                            <button
                                                                                className="btn btn-success btn-block"
                                                                                onClick={() => {
                                                                                    if (this.state.loadingSendBuy) return;
                                                                                    this.sendBuyList();
                                                                                }}
                                                                                disabled={this.state.loadingSendBuy}
                                                                                style={{
                                                                                    pointerEvents: this.state.loadingSendBuy ? "none" : "auto",
                                                                                    opacity: this.state.loadingSendBuy ? 0.65 : 1
                                                                                }}
                                                                            >
                                                                                {this.state.loadingSendBuy ? (
                                                                                    <>
                                                                                        <i className="fas fa-spinner fa-spin" /> กำลังส่งโพย...
                                                                                    </>
                                                                                ) : (
                                                                                    <>
                                                                                        <i className="fas fa-check" /> ยืนยันการส่งโพย
                                                                                    </>
                                                                                )}
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    บันทึกช่วยจำ:
                                                                    <textarea
                                                                        name="note"
                                                                        id="note_readonly"
                                                                        rows={2}
                                                                        placeholder="📝บันทึกช่วยจำ"
                                                                        readOnly
                                                                        className="form-control"
                                                                        value={this.state.note || ""}
                                                                    />
                                                                    <hr className="mb-2" />
                                                                    <div className="row px-3 mt-3">
                                                                        <div className="col-4 p-0">
                                                                            <button className="btn btn-dark btn-block rounded-0" onClick={this.capturePoy}>
                                                                                <i className="fas fa-save" /> บันทึกเลขชุด
                                                                            </button>
                                                                        </div>
                                                                        <div className="col-4 p-0">
                                                                            <button className="btn btn-light btn-block border rounded-0" onClick={this.openHistory}>
                                                                                <i className="fas fa-history" /> ประวัติโพย
                                                                            </button>
                                                                        </div>
                                                                        <div className="col-4 p-0">
                                                                            <button className="btn btn-primary btn-block rounded-0" onClick={this.betMore}>
                                                                                <i className="fas fa-plus" /> แทงต่อ
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div id="printpoy" style={{ zIndex: 202, fontWeight: "bold" }} className={`pagemodal-wrapper ${isOpenxprint ? "open" : ""}`}>
                                            <div className="container">
                                                <div className="pagemodal">
                                                    <div className="head bg-success">
                                                        <i className="fas fa-check-double" /> ส่งโพยสำเร็จ{" "}
                                                        <a role="button" onClick={this.closesallpoy} className="btn-close" />
                                                    </div>
                                                    <div className="content">
                                                        <div className="content-scroll p-2" style={{
                                                            flex: "1 1 auto",
                                                            height: "calc(100% - 200px)",
                                                            overflowY: "auto",
                                                            transition: "height .3s ease",
                                                        }} >
                                                            {/* Order Summary */}
                                                            <div className="border pb-2 mb-2">
                                                                <div className="row p-0 m-0">
                                                                    <div className="row p-0 m-0 col-12 bg-dark">
                                                                        <div className="col-7 pl-2 py-1 d-flex justify-content-start align-items-center">
                                                                            <img
                                                                                src={this.state.logoimg}
                                                                                alt="fifalotto"
                                                                                width={150}
                                                                                className="align-middle"
                                                                            />
                                                                        </div>
                                                                        <div
                                                                            className="col-5 pr-2 py-1 pl-0 text-white text-right"
                                                                            style={{ lineHeight: 1 }}
                                                                        >
                                                                            <small className="text-secondary">โพยเลขที่</small>
                                                                            <br />
                                                                            <h4 className="hbill">
                                                                                <small>#</small> <span id="poy_id">{this.state.track}</span>
                                                                            </h4>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-8 pl-2 pt-2">
                                                                        <table className="table table-sm table-responsive">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td colSpan={2} className="border-top-0">
                                                                                        <h5 className="hhuay bet_name">{this.state.room.name}</h5>
                                                                                    </td>
                                                                                </tr>
                                                                                <tr className="border">
                                                                                    <td className="table-secondary">
                                                                                        <i className="far fa-clock" />
                                                                                    </td>
                                                                                    <td>
                                                                                        <b className="hhuay_round bet_round">
                                                                                            งวดที่ {new Date(this.state.room?.drawTime).toLocaleDateString("th-TH", {
                                                                                                year: "numeric",
                                                                                                month: "2-digit",
                                                                                                day: "2-digit",
                                                                                            })}
                                                                                        </b>
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                        <span className="text-success">
                                                                            <i className="fas fa-vote-yea" /> ส่งโพยสำเร็จ
                                                                        </span>
                                                                    </div>
                                                                    <div className="col-4 pl-0 pt-2 text-right">
                                                                        <small>ทำรายการเมื่อ</small>
                                                                        <table className="table table-sm table-bordered">
                                                                            <tbody>
                                                                                <tr>
                                                                                    <td className="text-left table-secondary">วันที่</td>
                                                                                    <td className="text-left">
                                                                                        {new Date().toLocaleDateString("th-TH", {
                                                                                            year: "numeric",
                                                                                            month: "2-digit",
                                                                                            day: "2-digit",
                                                                                        })}
                                                                                    </td>
                                                                                </tr>
                                                                                <tr>
                                                                                    <td className="text-left table-secondary">เวลา</td>
                                                                                    <td className="text-left">
                                                                                        {new Date().toLocaleTimeString("th-TH", {
                                                                                            hour: "2-digit",
                                                                                            minute: "2-digit",
                                                                                            hour12: false,
                                                                                        })}
                                                                                    </td>
                                                                                </tr>
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                    <div
                                                                        className="col-12 py-2 text-center table-success border border-success border-right-0 border-left-0"
                                                                        style={{ transition: "none" }}
                                                                    >
                                                                        <span>ยอดรวม:</span>{" "}
                                                                        <span className="font-weight-bold text-success thb total_price">
                                                                            {this.state.totalPrice || 0}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Bet Details */}
                                                            <div className="col-12 py-3">
                                                                {Object.keys(this.state)
                                                                    .filter((key) => key.startsWith("ItemNumber_"))
                                                                    .map((key) => {
                                                                        const items = this.state[key];
                                                                        const keyid = key.replace("ItemNumber_", "");
                                                                        const setting = this.state.Dynamicsetting.find((s) => s.keyid === keyid);
                                                                        if (!setting || items.length === 0) return null;

                                                                        return (
                                                                            <div key={key} className="card card-huay">
                                                                                <div className="card-header card-header-sm">
                                                                                    <div className="row">
                                                                                        <div className="col-6 font-weight-bold text-success">{setting.key}</div>
                                                                                        <div className="col-3 text-right">ยอดจ่าย</div>
                                                                                        <div className="col-3 text-right">ราคา</div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="card-body card-body-sm">
                                                                                    <div className="row" id="pl_confim_teng_bon_3" style={{ fontWeight: "bold" }}>
                                                                                        {items.map((item, index) => (
                                                                                            <React.Fragment key={`${key}_${index}`}>
                                                                                                <div className="col-3">{index + 1}.</div>
                                                                                                <div className="col-3">
                                                                                                    {item.value || <span className="text-muted">ไม่มีข้อมูล</span>}
                                                                                                </div>
                                                                                                <div className="col-3 text-right thb">

                                                                                                    {item.payout != null
                                                                                                        ? <span className="text-danger ml-2">{item.payout}</span>
                                                                                                        : setting.value}

                                                                                                </div>
                                                                                                <div className="col-3 text-right thb">{item.price}</div>
                                                                                            </React.Fragment>
                                                                                        ))}
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        );
                                                                    })}
                                                            </div>
                                                            <div className="col-12 mt-0 mb-2">
                                                                <div className="alert alert-success p-1 px-2 mb-1 d-flex justify-content-between align-items-center">
                                                                    <span>
                                                                        <i className="fas fa-user-check" /> {player.username}
                                                                    </span>
                                                                    <span className="badge badge-secondary">©Dlotto.com</span>
                                                                </div>
                                                                <div className="alert px-0 pt-0 mb-0">
                                                                    <span className="badge badge-secondary">
                                                                        <i className="fas fa-marker" /> Note
                                                                    </span>
                                                                    <span className="text-secondary poynote" />
                                                                </div>
                                                            </div>

                                                        </div>

                                                        {/* Footer */}
                                                        <div className="fixbot p-2">
                                                            <div className="row px-3 mt-3">
                                                                <div className="col-4 p-0">
                                                                    <button className="btn btn-dark btn-block rounded-0" id="capturePoy">
                                                                        <i className="fas fa-save" /> บันทึกโพย{" "}
                                                                    </button>
                                                                </div>
                                                                <div className="col-4 p-0">
                                                                    <button className="btn btn-light btn-block border rounded-0 doo_poy">
                                                                        <i className="fas fa-history doo_poy" /> ประวัติโพย{" "}
                                                                    </button>
                                                                </div>
                                                                <div className="col-4 p-0">
                                                                    <button
                                                                        onClick={this.closesallpoy}
                                                                        className="btn btn-primary btn-block rounded-0"
                                                                    >
                                                                        <i className="fas fa-plus" /> แทงต่อ{" "}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </b>
                                </b>
                            </div>
                        </>
                    )}
                </>

            )
        }
        return (<>
            <div

                className="p-2 w-100 bg-light main-content align-self-stretch ng-star-inserted"
                style={{ minHeight: "calc((100vh - 139px) - 50px)" }}
            >
                <div

                    className="bgwhitealpha text-theme-secondary shadow-sm rounded p-2 xtarget col-lotto"
                >
                    <div className="text-center my-4">
                        <span style={{ fontSize: 100, lineHeight: "1.2" }}>
                            <i

                                className="fas fa-spinner fa-spin text-danger"
                            />
                        </span>
                        <h4

                            className="text-danger"
                            style={{ fontFamily: "inherit" }}
                        >
                            {" "}
                            กำลังรอผลหวย
                        </h4>
                    </div>
                    <div className="alert alert-danger text-center">
                        กรุณา คลิกที่ปุ่ม <b >Refresh</b>{" "}
                        เพื่อทำรายการใหม่อีกครั้ง
                    </div>
                </div>
                <div

                    className="bg-white p-2 rounded shadow-sm w-100 mb-5"
                >
                    <a
                        onClick={() => window.location.reload()}

                        href="javascript:void(0);"
                        className="btn btn-dark btn-block text-white"
                    >
                        <i className="fas fa-sync-alt" /> Refresh
                    </a>
                </div>
            </div>

        </>)
    }
}

export default Lottery;